<template>
  <div ref="topContainer">
    <div v-show="!isSurgConfirm">
      <MobileHeader :editSurgery="editSurgery" @confirmSurg="confirmSurg" />
      <DesktopHeader
        :editSurgery="editSurgery"
        :stage="stage"
        :activeDoctor="activeDoctor"
        @onPrevStage="onPrevStage"
        @goBackRoute="goBackRoute"
      />

      <ValidationObserver ref="surgform">
        <form
          v-if="doctorHistory"
          @submit.prevent="confirmSurg"
          name="surgeryForm"
          class="surgeryFormEl"
        >
          <section class="add_new_inner wrap-surg-add">
            <!-- Stage 2 -->
            <PatientDetails v-if="stage === 2 || isMobile" :surg="surg" />

            <!-- Stage 3 -->
            <div
              class="subtitle center no_mobile"
              v-if="stage === 3 || isMobile"
            >
              הזן פרטי ניתוח
            </div>
            <h2 v-show="isMobile" class="subtitle_inner">
              הזן פרטי ניתוח:
            </h2>
            <!-- Stage 3 - line 1 -->
            <div
              v-if="stage === 3 || isMobile"
              class="book_surgery toggleContainer desk_inner_width"
              :class="{ active: toggleStates.selectedSurgery }"
              ref="selected_surgery"
            >
              <a
                class="book_surgery_top flex"
                href="javascript:void(0)"
                @click="toggleSection('selectedSurgery')"
              >
                <span class="title flex is--fit desk-flex--between">
                  פרטי ניתוח מתוכנן (או מס׳ פעולות לניתוח)**

                  <Tags :isRequired="true" />
                </span>
                <span class="plus-wrap flex m-flex--center">
                  <span class="plus"></span>
                </span>
              </a>
              <div
                v-show="toggleStates.selectedSurgery"
                class="book_surgery_open toggleInner surg-info-container"
                :class="{ disabled: isInsuranceRowsLoading }"
              >
                <div class="no_mobile surg_list_head desk-flex">
                  <div class="surg_list-1">ניתוח ראשי</div>
                  <div class="surg_list-2">צד</div>
                  <!-- <div class="surg_list-2">תחום</div> -->
                  <div class="surg_list-3">שם/קוד ניתוח (בי״ח)*</div>
                  <div class="surg_list-4">שם/קוד ניתוח (קליני ICD9)*</div>
                  <div class="surg_list-5">
                    זמן הניתוח מהכניסה עד היציאה מהחדר*
                  </div>
                </div>
                <SelectedSurgeryInfo
                  :surgery_categories="surgery_categories"
                  :rows="surg.selected_surgery"
                  :payment_token="surg.payment_token"
                  @editSelectedBlock="e => editSelectedBlock('surgery', e)"
                  @removeSelectedBlock="e => removeSelectedBlock('surgery', e)"
                />
                <div
                  v-show="!surg.payment_token"
                  class="surg_list_body inner_group bg--white desk-no-pad desk-flex desk-flex--top surg-info-container"
                >
                  <div class="add_new_row flex surg_list-1">
                    <div class="add_new_row_col1 desk-hide">ניתוח ראשי</div>
                    <div class="add_new_row_col2">
                      <span
                        class="surgery-check flex"
                        :class="{
                          active: surg_info.is_primary == 'primary'
                        }"
                        @click.stop="onPrimary"
                      >
                        <span class="surgery-check-ic block"></span>
                      </span>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-2">
                    <div class="add_new_row_col1 desk-hide">צד</div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block">
                        <select2 dir="rtl" v-model="surg_info.side">
                          <option value="">בחר צד</option>
                          <option value="Right">Right</option>
                          <option value="BIL">BIL</option>
                          <option value="Left">Left</option>
                        </select2>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="add_new_row flex surg_list-2">
                    <div class="add_new_row_col1 desk-hide">תחום</div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block">
                        <select2 name="" dir="rtl" v-model="surg_info.category">
                          <option value="">בחר תחום</option>
                          <option
                            :value="row.current_surgery_category_code"
                            v-for="(row, index) in surgery_categories"
                            :key="
                              index + '-' + row.current_surgery_category_name
                            "
                          >
                            {{ row.current_surgery_category_name }}
                          </option>
                        </select2>
                      </div>
                    </div>
                  </div> -->
                  <div class="add_new_row flex surg_list-3">
                    <div class="add_new_row_col1 desk-hide">
                      שם/קוד ניתוח (בי״ח)*
                    </div>
                    <div class="add_new_row_col2">
                      <div
                        class="input-opacity relative"
                        :class="
                          surg_info.code_name_hospital &&
                          isEnglish(surg_info.code_name_hospital)
                            ? 'left-multiselect'
                            : 'right-multiselect'
                        "
                      >
                        <div
                          v-show="
                            surg_info.code_name_hospital !== '' &&
                              !disabledByAutocomplete.hospital
                          "
                          @click="resetValue('code_name_hospital')"
                          class="surg-clear-btn"
                          :class="{ 'btn-mobile': isMobile }"
                          style="background: #f5f5f5"
                        >
                          X
                        </div>
                        <multiselect
                          placeholder="בחר/הקלד שם/קוד ניתוח"
                          v-model="surg_info.code_name_hospital"
                          @search-change="onSearch($event, 'current_surgery')"
                          :options="
                            surgery_codes_auto.length
                              ? surgery_codes_auto
                              : surgery_codes
                          "
                          :searchable="true"
                          :disabled="
                            !surgery_codes?.length ||
                              disabledByAutocomplete.hospital ||
                              (surg_info.code_name_hospital !== '' &&
                                !disabledByAutocomplete.hospital)
                          "
                          :allow-empty="false"
                          :options-limit="limit.current_surgery"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-4">
                    <div class="add_new_row_col1 desk-hide">
                      שם/קוד ניתוח<br />
                      (קליני ICD9)*
                    </div>
                    <div class="add_new_row_col2">
                      <div
                        class="input-opacity relative"
                        :class="
                          surg_info.code_name_clinical &&
                          isEnglish(surg_info.code_name_clinical)
                            ? 'left-multiselect'
                            : 'right-multiselect'
                        "
                      >
                        <div
                          v-show="
                            surg_info.code_name_clinical !== '' &&
                              !disabledByAutocomplete.clinical
                          "
                          @click="resetValue('code_name_clinical')"
                          class="surg-clear-btn"
                          :class="{ 'btn-mobile': isMobile }"
                        >
                          X
                        </div>
                        <multiselect
                          placeholder="בחר/הקלד שם/קוד ניתוח קליני"
                          v-model="surg_info.code_name_clinical"
                          @search-change="onSearch($event, 'current_procedure')"
                          :options="
                            surgery_codes_clinic_auto.length
                              ? surgery_codes_clinic_auto
                              : surgery_codes_clinic
                          "
                          :searchable="true"
                          :disabled="
                            !surgery_codes_clinic?.length ||
                              disabledByAutocomplete.clinical
                          "
                          :allow-empty="false"
                          :options-limit="limit.current_procedure"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-5">
                    <div class="add_new_row_col1 desk-hide">
                      זמן הניתוח מהכניסה עד היציאה מהחדר*
                    </div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity surg-time">
                        <validation-provider
                          ref="end_time"
                          name="end_time"
                          :rules="{
                            requiredSurgTime: [surg_info.code_name_hospital],
                            timeFormat: [null],
                            interval: [null]
                          }"
                          v-slot="{ errors }"
                        >
                          <cleave
                            :value="surg_info.duration"
                            :options="options"
                            @input="onCleave"
                            @focus.native="e => e.target.select()"
                            name="time"
                          ></cleave>
                          <span class="error-message">{{ errors[0] }}</span>
                        </validation-provider>
                      </div>
                    </div>
                  </div>
                  <ActionsMsgRow
                    :errMsg="errorMessages.surgery"
                    :isOnEdit="surge_info_edit"
                    :isSurgInfo="true"
                    @addBlock="addBlock('surgery')"
                    @removeSelectedBlock="
                      resetRow('surg_info', 'surge_info_edit')
                    "
                  />
                </div>
                <span
                  v-show="surg.payment_token"
                  class="surg-side-note text--20"
                  style="margin-top: 6px;"
                >
                  בוצע חיוב ונפתח תיק מטופל.<br />
                  לא ניתן לערוך לעזרה יש ליצור קשר עם מוקד חדר ניתוח
                </span>
              </div>
            </div>
            <!-- Stage 3 - line 2 -->
            <div
              v-if="stage === 3 || isMobile"
              ref="insuranceType"
              class="book_surgery toggleContainer desk_inner_width"
              :class="{ active: toggleStates.insuranceType }"
            >
              <a
                class="book_surgery_top flex"
                href="javascript:void(0)"
                @click="toggleSection('insuranceType')"
              >
                <span class="title flex is--fit desk-flex--between">
                  <span>
                    פרטי גורם משלם ומבטח**
                  </span>

                  <Tags :isRequired="true" />
                </span>
                <span class="plus-wrap flex m-flex--center">
                  <span class="plus"></span>
                </span>
              </a>

              <div
                v-show="toggleStates.insuranceType"
                class="book_surgery_open toggleInner"
              >
                <div
                  class="inner_group bg--white desk-no-pad desk-flex desk-flex--top desk-flex--start"
                >
                  <div class="add_new_row flex">
                    <div class="add_new_row_col1">
                      האם מבוטח בחברת ביטוח?*
                    </div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block">
                        <validation-provider
                          name="isInsuranceCompany"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <select2 dir="rtl" v-model="surg.isInsuranceCompany">
                            <option
                              v-for="option in insuranceQuestions.booleanOptions"
                              :key="option.text"
                              :value="option.value"
                            >
                              {{ option.text }}
                            </option>
                          </select2>
                          <span class="error-message">{{ errors[0] }}</span>
                        </validation-provider>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex">
                    <div class="add_new_row_col1">
                      באיזו קופת חולים מבוטח המטופל?*
                    </div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block">
                        <validation-provider
                          name="insurance_type"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <select2 dir="rtl" v-model="surg.insurance_type">
                            <option
                              v-for="option in insuranceQuestions.careServicesOptions"
                              :key="option.value"
                              :value="option.value"
                            >
                              {{ option.text }}
                            </option>
                          </select2>
                          <span class="error-message">{{ errors[0] }}</span>
                        </validation-provider>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex">
                    <div class="add_new_row_col1">
                      איזה גורם משלם תרצה להפעיל?*
                    </div>
                    <div class="add_new_row_col2">
                      <div
                        class="input-opacity desk-block"
                        :class="{ disabled: !surg.insurance_type }"
                      >
                        <validation-provider
                          name="payType"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <select2
                            dir="rtl"
                            v-model="payType"
                            :disabled="!surg.insurance_type"
                          >
                            <option
                              v-for="option in payOptions"
                              :key="option.value"
                              :value="option.value"
                            >
                              {{ option.text }}
                            </option>
                          </select2>
                          <span class="error-message">{{ errors[0] }}</span>
                        </validation-provider>
                      </div>
                    </div>
                  </div>
                  <template v-if="surg.isInsuranceCompany == 'true'">
                    <div class="add_new_row flex">
                      <div class="add_new_row_col1">
                        באיזו חברת ביטוח?*
                      </div>
                      <div class="add_new_row_col2">
                        <div class="input-opacity desk-block">
                          <validation-provider
                            name="insuranceCompany"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <select2 dir="rtl" v-model="surg.insuranceCompany">
                              <option
                                v-for="option in insuranceQuestions.insuranceCompanyOptions"
                                :key="option.value"
                                :value="option.value"
                              >
                                {{ option.text }}
                              </option>
                            </select2>
                            <span class="error-message">{{ errors[0] }}</span>
                          </validation-provider>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="payType === 'חברת ביטוח'"
                      class="add_new_row flex"
                    >
                      <div class="add_new_row_col1">
                        מעוניין שבית החולים יפנה בשמך לחברת הביטוח?*
                      </div>
                      <div class="add_new_row_col2">
                        <div class="input-opacity desk-block">
                          <input
                            v-if="payType != 'חברת ביטוח'"
                            type="text"
                            placeholder=""
                            disabled
                          />
                          <validation-provider
                            v-else
                            name="insuranceClaim"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <select2
                              dir="rtl"
                              v-model="surg.handle_insurance_claim_by_hmc"
                            >
                              <option value="">בחר</option>
                              <option value="approved">כן</option>
                              <option value="denied">לא</option>
                            </select2>
                            <span class="error-message">{{ errors[0] }}</span>
                          </validation-provider>
                        </div>
                      </div>
                    </div>
                  </template>
                  <div v-if="payType == 'חברת ביטוח'" class="add_new_row flex">
                    <div class="add_new_row_col1">
                      האם לגבות שכר טרחה?*
                    </div>
                    <div class="add_new_row_col2">
                      <div
                        class="input-opacity"
                        :class="{
                          disabled: payType == '' || isPayTypeCareService
                        }"
                      >
                        <validation-provider
                          name="isPayRequired"
                          :rules="
                            payType == '' || isPayTypeCareService
                              ? ''
                              : 'required'
                          "
                          v-slot="{ errors }"
                        >
                          <select2
                            dir="rtl"
                            v-model="isPayRequired"
                            :disabled="payType == '' || isPayTypeCareService"
                          >
                            <option
                              v-for="option in insuranceQuestions.booleanOptions"
                              :key="option.text"
                              :value="option.value"
                            >
                              {{ option.text }}
                            </option>
                          </select2>
                          <span class="error-message">{{ errors[0] }}</span>
                        </validation-provider>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="
                      isPayRequired == 'true' ||
                        payType == 'פרטי' ||
                        isRHINOPLASTYSuregry
                    "
                    class="add_new_row flex"
                  >
                    <div class="add_new_row_col1">
                      שכר טרחה
                      <span class="note mobile_only">
                        שכ״ט ניתוח פרטי או בהסכם עם חב׳ הביטוח (בש״ח)
                      </span>
                    </div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity">
                        <input
                          type="tel"
                          v-mask="'#'.repeat(10)"
                          v-model="surg.doctor_fee"
                          placeholder="₪"
                          autocomplete="off"
                          :disabled="
                            (payType == '' || isPayTypeCareService) &&
                              !isRHINOPLASTYSuregry
                          "
                        />
                      </div>
                      <span class="note no_mobile">
                        שכ״ט ניתוח פרטי או בהסכם עם חב׳ הביטוח (בש״ח)
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Stage 3 - line 3 -->
            <div
              v-if="
                isInsuranceType &&
                  (isPayTypeCareService ||
                    surg.isInsuranceCompany == 'false') &&
                  insurance_surgery_temp.length &&
                  (stage === 3 || isMobile)
              "
              class="book_surgery toggleContainer desk_inner_width"
              :class="{ active: toggleStates.insuranceSurg }"
              ref="insuranceSurg"
            >
              <a
                class="book_surgery_top flex"
                href="javascript:void(0)"
                @click="toggleSection('insuranceSurg')"
              >
                <span class="title flex is--fit desk-flex--between">
                  הזן פרטי ניתוח של גורם מבטח**

                  <Tags :isRequired="true" />
                </span>
                <span class="plus-wrap flex m-flex--center">
                  <span class="plus"></span>
                </span>
              </a>
              <div
                v-show="toggleStates.insuranceSurg"
                class="book_surgery_open toggleInner"
              >
                <div v-for="(item, i) in insurance_surgery_temp" :key="i">
                  <div class="no_mobile surg_list_head desk-flex">
                    <div class="surg_list-1">מבטח</div>
                    <div class="surg_list-2">קוד ניתוח מדיקל</div>
                    <!-- <div class="surg_list-2">תחום</div> -->
                    <div class="surg_list-3">שם/קוד ניתוח של המבטח*</div>
                    <div class="surg_list-5">הערות</div>
                  </div>
                  <!-- <InsuranceSurgeryInfo
                    :insurance_type="surg.insurance_type"
                    :rows="surg.insurance_surgery"
                    :selectedSurgery="item.code_name_hospital"
                  /> -->
                  <div
                    class="surg_list_body inner_group bg--white desk-no-pad desk-flex desk-flex--top"
                  >
                    <div class="add_new_row flex surg_list-1">
                      <div class="add_new_row_col1 desk-hide">מבטח</div>
                      <div class="add_new_row_col2">
                        <div class="input-opacity desk-block">
                          <div class="input_area_opcity">
                            <validation-provider
                              v-if="
                                item.code_name_hospital === '1 > RHINOPLASTY' &&
                                  payType === 'כללית מושלם'
                              "
                              name="specialInsuranceCode"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <select2
                                dir="rtl"
                                :isSpecialInsuranceCode="i"
                                v-model="item.insurance_type"
                              >
                                <option value="">בחר</option>
                                <option value="פרטי">פרטי</option>
                                <option
                                  v-if="surg.isInsuranceCompany === 'true'"
                                  value="חברת ביטוח"
                                >
                                  חברת ביטוח
                                </option>
                                <option value="כללית מושלם">כללית</option>
                              </select2>
                              <span class="error-message">{{ errors[0] }}</span>
                            </validation-provider>
                            <textarea
                              v-else-if="isPayTypeCareService"
                              class="insurance-disabled"
                              v-model="payType"
                              placeholder="מבטח"
                              disabled
                            ></textarea>
                            <textarea
                              v-else
                              class="insurance-disabled"
                              v-model="surg.insurance_type"
                              placeholder="מבטח"
                              disabled
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="add_new_row flex surg_list-2">
                      <div class="add_new_row_col1 desk-hide">קוד ניתוח</div>
                      <!-- <div class="add_new_row_col1 desk-hide">תחום</div> -->
                      <div class="add_new_row_col2">
                        <div class="input-opacity desk-block">
                          <input
                            class="english-textarea"
                            v-model="item.code_name_hospital"
                            disabled
                          />
                          <!-- <multiselect
                          placeholder=""
                          v-model="insurance_info.category"
                          :options="insurance_surgery_categories"
                          :searchable="true"
                          :allow-empty="false"
                          :disabled="
                            !insurance_surgery_categories ||
                              !insurance_surgery_categories.length
                          "
                        ></multiselect> -->
                        </div>
                      </div>
                    </div>
                    <div class="add_new_row flex surg_list-3">
                      <div class="add_new_row_col1 desk-hide">
                        שם/קוד ניתוח*
                      </div>
                      <div class="add_new_row_col2">
                        <div class="input-opacity">
                          <validation-provider
                            :name="'insuranceSurgeryCode' + i"
                            :rules="
                              item.insurance_surgery_codes?.length
                                ? 'required'
                                : ''
                            "
                            v-slot="{ errors }"
                          >
                            <multiselect
                              placeholder=""
                              v-model="item.code"
                              :options="item.insurance_surgery_codes || []"
                              :searchable="true"
                              :allow-empty="false"
                              :options-limit="limit.current_insurance"
                              :disabled="
                                !item.insurance_surgery_codes?.length ||
                                  item.insurance_surgery_codes?.length == 1
                              "
                            ></multiselect>
                            <span class="error-message">{{ errors[0] }}</span>
                          </validation-provider>
                        </div>
                      </div>
                    </div>
                    <div class="add_new_row flex surg_list-5">
                      <div class="add_new_row_col1 w-100 desk-hide">הערות</div>
                      <div class="input_area_opcity">
                        <textarea
                          v-model="item.notes"
                          placeholder="פירוט..."
                          autocomplete="off"
                        ></textarea>
                      </div>
                    </div>
                    <span
                      v-if="i == insurance_surgery_temp.length - 1"
                      class="surg-side-note text--20"
                    >
                      לתשומת ליבך, המערכת מתאימה אוטומטית את קוד/י הקופה לקוד/י
                      ביה"ח אותו/ם בחרת מעלה.
                      <br />
                      במידה והקוד המותאם לרשומה שגוי, יש לערוך ולבחור קוד בי"ח
                      אחר.
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Stage 3 - line 4 -->
            <div
              v-if="stage === 3 || isMobile"
              class="book_surgery toggleContainer desk_inner_width"
              :class="{ active: toggleStates.treatmentHistory }"
            >
              <a
                class="book_surgery_top flex"
                href="javascript:void(0)"
                @click="toggleSection('treatmentHistory')"
              >
                <span class="title flex is--fit">
                  הסטוריית המחלה (אינדיקציה לניתוח ומחלה נוכחית)
                  <span class="only-doc-fill flex">
                    <img src="/assets/img/svg/doctor-fill.svg" />
                    למילוי ע״י הרופא
                  </span>
                </span>
                <span class="plus-wrap flex m-flex--center">
                  <span class="plus"></span>
                </span>
              </a>
              <div
                v-show="toggleStates.treatmentHistory"
                class="book_surgery_open toggleInner"
              >
                <div class="inner_group bg--white desk-no-pad">
                  <div class="add_new_row flex desk-no-pad desk-w-100">
                    <div class="add_new_row_col1 w-100">
                      פרט מתי התחילו הסימפטומים, מתי אובחן, מה השיקול הרפואי
                      להחלטה על ניתוח זה, האם המחלה היא עקב גיל, עקב טראומה, עקב
                      ניתוח קודם שכשל
                    </div>
                    <div class="input_area_opcity textarea-big only-doc-mark">
                      <div class="only-doc-mark-in">למילוי ע״י הרופא</div>
                      <textarea
                        v-model="surg.treatment_history"
                        placeholder="פירוט..."
                        autocomplete="off"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Stage 3 - line 5 -->
            <div
              v-if="stage === 3 || isMobile"
              class="book_surgery toggleContainer desk_inner_width"
              :class="{ active: toggleStates.currentDiagnosis }"
              ref="currentDiagnosis"
            >
              <a
                class="book_surgery_top flex"
                href="javascript:void(0)"
                @click="toggleSection('currentDiagnosis')"
              >
                <span class="title flex is--fit">
                  אבחנה נוכחית לפעולה (באנגלית)
                  <span class="only-doc-fill flex">
                    <img src="/assets/img/svg/doctor-fill.svg" />
                    למילוי ע״י הרופא
                  </span>
                </span>
                <span class="plus-wrap flex m-flex--center">
                  <span class="plus"></span>
                </span>
              </a>

              <div
                v-show="toggleStates.currentDiagnosis"
                class="book_surgery_open toggleInner"
              >
                <div class="no_mobile surg_list_head desk-flex">
                  <div class="surg_list-1">צד</div>
                  <div class="surg_list-3">שם אבחנה (ניתן לחפש לפי קוד)*</div>
                  <div class="surg_list-3">קוד אבחנה</div>
                  <div class="surg_list-5">הערות</div>
                </div>
                <CurrentDiagnosisInfo
                  :rows="surg.current_diagnosis"
                  @editSelectedBlock="e => editSelectedBlock('diagnosis', e)"
                  @removeSelectedBlock="
                    e => removeSelectedBlock('diagnosis', e)
                  "
                />
                <div
                  class="surg_list_body inner_group bg--white desk-no-pad desk-flex desk-flex--top"
                >
                  <div class="add_new_row flex surg_list-1">
                    <div class="add_new_row_col1 desk-hide">צד</div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block">
                        <select2
                          name=""
                          dir="rtl"
                          v-model="diagnosis_info.side"
                        >
                          <option value="">בחר צד</option>
                          <option value="Right">Right</option>
                          <option value="BIL">BIL</option>
                          <option value="Left">Left</option>
                        </select2>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-3">
                    <div class="add_new_row_col1 desk-hide">
                      שם אבחנה*
                      <span class="note block">ניתן לחפש לפי קוד</span>
                    </div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block relative">
                        <div
                          v-show="diagnosis_info.name !== ''"
                          @click="diagnosis_info.name = ''"
                          class="surg-clear-btn"
                          :class="{ 'btn-mobile': isMobile }"
                        >
                          X
                        </div>
                        <multiselect
                          placeholder=""
                          v-model="diagnosis_info.name"
                          @search-change="onSearch($event, 'current_diagnosis')"
                          :options="current_diagnosis"
                          :searchable="true"
                          :allow-empty="false"
                          :options-limit="limit.current_diagnosis"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-3">
                    <div class="add_new_row_col1 desk-hide">קוד אבחנה</div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block">
                        <input disabled v-model="diagnosis_info.code" />
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-5">
                    <div class="add_new_row_col1 w-100 desk-hide">הערות</div>
                    <div class="input_area_opcity">
                      <textarea
                        v-model="diagnosis_info.notes"
                        placeholder="פירוט..."
                        autocomplete="off"
                      ></textarea>
                    </div>
                  </div>
                  <ActionsMsgRow
                    :errMsg="errorMessages.diagnosis"
                    :isOnEdit="diagnosis_info_edit"
                    @addBlock="addBlock('diagnosis')"
                    @removeSelectedBlock="
                      resetRow('diagnosis_info', 'diagnosis_info_edit')
                    "
                  />
                </div>
              </div>
            </div>
            <!-- Stage 3 - line 6 -->
            <div
              v-if="stage === 3 || isMobile"
              class="book_surgery toggleContainer desk_inner_width"
              :class="{ active: toggleStates.pastDiagnosis }"
              ref="past_diagnosis"
            >
              <a
                class="book_surgery_top flex"
                href="javascript:void(0)"
                @click="toggleSection('pastDiagnosis')"
              >
                <span class="title flex is--fit desk-flex--start">
                  <span class="flex flex--start is--fit">
                    <span>
                      אבחנות רקע*
                    </span>
                    <span
                      class="surgery-check flex"
                      :class="{
                        active: surg.background_diagnosis == 'healthy'
                      }"
                      @click.stop="onHealty"
                    >
                      <span class="surgery-check-ic block"></span>
                      בריא בדרך כלל
                    </span>
                  </span>

                  <Tags :isDoctor="true" :isRequired="true" />
                </span>

                <span class="plus-wrap flex m-flex--center">
                  <span class="plus"></span>
                </span>
              </a>
              <div
                v-show="toggleStates.pastDiagnosis"
                class="book_surgery_open toggleInner"
                :class="{ 'section-disabled': isHealty }"
              >
                <div class="no_mobile surg_list_head desk-flex">
                  <div class="surg_list-1">צד</div>
                  <div class="surg_list-3">שם אבחנה (ניתן לחפש לפי קוד)*</div>
                  <div class="surg_list-3">קוד אבחנה</div>
                  <div class="surg_list-5">הערות</div>
                </div>
                <PastDiagnosisInfo
                  :rows="surg.past_diagnosis"
                  @editSelectedBlock="
                    e => editSelectedBlock('past_diagnosis', e)
                  "
                  @removeSelectedBlock="
                    e => removeSelectedBlock('past_diagnosis', e)
                  "
                />
                <div
                  class="surg_list_body inner_group bg--white desk-no-pad desk-flex desk-flex--top"
                >
                  <div class="add_new_row flex surg_list-1">
                    <div class="add_new_row_col1 desk-hide">צד</div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block">
                        <select2
                          name=""
                          dir="rtl"
                          v-model="past_diagnosis.side"
                        >
                          <option value="">בחר צד</option>
                          <option value="Right">Right</option>
                          <option value="BIL">BIL</option>
                          <option value="Left">Left</option>
                        </select2>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-3">
                    <div class="add_new_row_col1 desk-hide">
                      שם אבחנה*
                      <span class="note block">ניתן לחפש לפי קוד</span>
                    </div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block relative">
                        <div
                          v-show="past_diagnosis.diagnosis_name !== ''"
                          @click="past_diagnosis.diagnosis_name = ''"
                          class="surg-clear-btn"
                          :class="{ 'btn-mobile': isMobile }"
                        >
                          X
                        </div>
                        <multiselect
                          placeholder=""
                          v-model="past_diagnosis.diagnosis_name"
                          @search-change="onSearch($event, 'past_diagnosis')"
                          :options="past_diagnosis_options"
                          :searchable="true"
                          :allow-empty="false"
                          :options-limit="limit.past_diagnosis"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-3">
                    <div class="add_new_row_col1 desk-hide">קוד אבחנה</div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block">
                        <input
                          disabled
                          v-model="past_diagnosis.diagnosis_number"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-5">
                    <div class="add_new_row_col1 w-100 desk-hide">הערות</div>
                    <div class="input_area_opcity">
                      <textarea
                        v-model="past_diagnosis.notice"
                        placeholder="פירוט..."
                        autocomplete="off"
                      ></textarea>
                    </div>
                  </div>
                  <ActionsMsgRow
                    :errMsg="errorMessages.past_diagnosis"
                    :isOnEdit="past_diagnosis_edit"
                    @addBlock="addBlock('past_diagnosis')"
                    @removeSelectedBlock="
                      resetRow('past_diagnosis', 'past_diagnosis_edit')
                    "
                  />
                </div>
              </div>
            </div>
            <!-- Stage 3 - line 7 -->
            <div
              v-if="stage === 3 || isMobile"
              ref="phisycal_check"
              class="book_surgery toggleContainer desk_inner_width"
              :class="{ active: toggleStates.physicalCheck }"
            >
              <a
                class="book_surgery_top flex"
                href="javascript:void(0)"
                @click="toggleSection('physicalCheck')"
              >
                <span class="title flex is--fit desk-flex--between">
                  <span>
                    בדיקה גופנית*
                  </span>
                  <Tags :isDoctor="true" :isRequired="true" />
                </span>
                <span class="plus-wrap flex m-flex--center">
                  <span class="plus"></span>
                </span>
              </a>
              <div
                v-show="toggleStates.physicalCheck"
                class="book_surgery_open toggleInner"
              >
                <div class="inner_group bg--white desk-no-pad">
                  <div class="add_new_row flex desk-w-100 desk-no-pad">
                    <div class="add_new_row_col1 w-100">
                      פרט תוצאות בדיקה גופנית
                    </div>
                    <div class="input_area_opcity textarea-big only-doc-mark">
                      <div class="only-doc-mark-in">למילוי ע״י הרופא</div>
                      <validation-provider
                        name="phisycal_check"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <textarea
                          v-model="surg.phisycal_check"
                          placeholder="פירוט..."
                          autocomplete="off"
                        ></textarea>
                        <span class="error-message">{{ errors[0] }}</span>
                      </validation-provider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Stage 3 - line 8 -->
            <div
              v-if="stage === 3 || isMobile"
              class="book_surgery toggleContainer desk_inner_width"
              :class="{ active: toggleStates.medicationSensitivity }"
              ref="medication_sensitivity"
            >
              <a
                class="book_surgery_top flex"
                href="javascript:void(0)"
                @click="toggleSection('medicationSensitivity')"
              >
                <span class="title flex is--fit desk-flex--start">
                  <span class="flex flex--start is--fit">
                    רגישות לתרופות
                    <span
                      class="surgery-check flex"
                      :class="{ active: surg.no_drug_sens }"
                      @click.stop="surg.no_drug_sens = !surg.no_drug_sens"
                    >
                      <span class="surgery-check-ic block"></span> לא ידועה
                      רגישות
                    </span>
                  </span>

                  <span class="only-doc-fill flex">
                    <img src="/assets/img/svg/doctor-fill.svg" />
                    למילוי ע״י הרופא
                  </span>
                </span>
                <span class="plus-wrap flex m-flex--center">
                  <span class="plus"></span>
                </span>
              </a>
              <div
                v-show="toggleStates.medicationSensitivity"
                class="book_surgery_open toggleInner"
                :class="{ 'section-disabled': surg.no_drug_sens }"
              >
                <div class="no_mobile surg_list_head desk-flex">
                  <div class="surg_list-1">תגובה*</div>
                  <div class="surg_list-3">חומרה*</div>
                  <div class="surg_list-3">שם תרופה*</div>
                  <div class="surg_list-5">הערות</div>
                </div>
                <MedicationSensitivityInfo
                  :rows="surg.medication_sensitivity"
                  @editSelectedBlock="e => editSelectedBlock('medication', e)"
                  @removeSelectedBlock="
                    e => removeSelectedBlock('medication', e)
                  "
                />
                <div
                  class="surg_list_body inner_group bg--white desk-no-pad desk-flex desk-flex--top"
                >
                  <div class="add_new_row flex surg_list-1">
                    <div class="add_new_row_col1 desk-hide">תגובה*</div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block">
                        <select2
                          name=""
                          dir="rtl"
                          v-model="medication_sensitivity_info.reaction"
                        >
                          <option value="">בחר תגובה</option>
                          <option>פריחה</option>
                          <option>גירוד</option>
                          <option>קוצר נשימה</option>
                          <option>כאבי בטן</option>
                          <option>רעד</option>
                          <option>הקאות</option>
                          <option>שלשולים</option>
                          <option>חולשה</option>
                          <option>ירידה ב-PLT</option>
                          <option>ירידת לחץ דם</option>
                          <option>נפיחות</option>
                          <option>הלם אנפילקטי</option>
                          <option>שוק</option>
                          <option>אנגיואדמה</option>
                          <option>חנק</option>
                          <option>אודם</option>
                          <option>אפניאה</option>
                          <option>בצקת</option>
                          <option>פרכוס</option>
                          <option>לא ידוע</option>
                          <option>אחר</option>
                        </select2>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-3">
                    <div class="add_new_row_col1 desk-hide">חומרה*</div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block">
                        <select2
                          name=""
                          dir="rtl"
                          v-model="medication_sensitivity_info.severity"
                        >
                          <option value="">בחר חומרה</option>
                          <option>קלה</option>
                          <option>בינוני</option>
                          <option>קשה</option>
                          <option>הלם</option>
                          <option>בספק</option>
                        </select2>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-3">
                    <div class="add_new_row_col1 desk-hide">שם תרופה*</div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block relative">
                        <div
                          v-show="medication_sensitivity_info.name !== ''"
                          @click="medication_sensitivity_info.name = ''"
                          class="surg-clear-btn"
                          :class="{ 'btn-mobile': isMobile }"
                        >
                          X
                        </div>
                        <multiselect
                          placeholder=""
                          v-model="medication_sensitivity_info.name"
                          @search-change="
                            onSearch($event, 'medication_sensitivity')
                          "
                          :options="medication_sensitivity"
                          :searchable="true"
                          :allow-empty="false"
                          :options-limit="limit.medication_sensitivity"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-5">
                    <div class="add_new_row_col1 w-100 desk-hide">הערות</div>
                    <div class="input_area_opcity">
                      <textarea
                        v-model="medication_sensitivity_info.notes"
                        placeholder="פירוט.."
                        autocomplete="off"
                      ></textarea>
                    </div>
                  </div>
                  <ActionsMsgRow
                    :errMsg="errorMessages.medication"
                    :isOnEdit="medication_sensitivity_info_edit"
                    @addBlock="addBlock('medication')"
                    @removeSelectedBlock="
                      resetRow(
                        'medication_sensitivity_info',
                        'medication_sensitivity_info_edit'
                      )
                    "
                  />
                </div>
              </div>
            </div>
            <!-- Stage 3 - line 9 -->
            <div
              v-if="stage === 3 || isMobile"
              class="book_surgery toggleContainer desk_inner_width"
              :class="{ active: toggleStates.materialSensitivity }"
              ref="material_sensitivity"
            >
              <a
                class="book_surgery_top flex"
                href="javascript:void(0)"
                @click="toggleSection('materialSensitivity')"
              >
                <span class="title flex is--fit desk-flex--start">
                  <span class="flex flex--start is--fit">
                    רגישות לחומרים
                    <span
                      class="surgery-check flex"
                      :class="{ active: surg.no_material_sens }"
                      @click.stop="
                        surg.no_material_sens = !surg.no_material_sens
                      "
                    >
                      <span class="surgery-check-ic block"></span> לא ידועה
                      רגישות
                    </span>
                  </span>

                  <span class="only-doc-fill flex">
                    <img src="/assets/img/svg/doctor-fill.svg" />
                    למילוי ע״י הרופא
                  </span>
                </span>
                <span class="plus-wrap flex m-flex--center">
                  <span class="plus"></span>
                </span>
              </a>
              <div
                v-show="toggleStates.materialSensitivity"
                class="book_surgery_open toggleInner"
                :class="{ 'section-disabled': surg.no_material_sens }"
              >
                <div class="no_mobile surg_list_head desk-flex">
                  <div class="surg_list-1">תגובה*</div>
                  <div class="surg_list-3">חומרה*</div>
                  <div class="surg_list-3">שם חומר (בעברית)*</div>
                  <div class="surg_list-5">הערות</div>
                </div>
                <MaterialSensitivityInfo
                  :rows="surg.material_sensitivity"
                  @editSelectedBlock="e => editSelectedBlock('material', e)"
                  @removeSelectedBlock="e => removeSelectedBlock('material', e)"
                />
                <div
                  class="surg_list_body inner_group bg--white desk-no-pad desk-flex desk-flex--top"
                >
                  <div class="add_new_row flex surg_list-1">
                    <div class="add_new_row_col1 desk-hide">תגובה*</div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block">
                        <select2
                          name=""
                          dir="rtl"
                          v-model="material_sensitivity_info.reaction"
                        >
                          <option value="">בחר תגובה</option>
                          <option>פריחה</option>
                          <option>גירוד</option>
                          <option>קוצר נשימה</option>
                          <option>כאבי בטן</option>
                          <option>רעד</option>
                          <option>הקאות</option>
                          <option>שלשולים</option>
                          <option>חולשה</option>
                          <option>ירידה ב-PLT</option>
                          <option>ירידת לחץ דם</option>
                          <option>נפיחות</option>
                          <option>הלם אנפילקטי</option>
                          <option>שוק</option>
                          <option>אנגיואדמה</option>
                          <option>חנק</option>
                          <option>אודם</option>
                          <option>אפניאה</option>
                          <option>בצקת</option>
                          <option>פרכוס</option>
                          <option>לא ידוע</option>
                          <option>אחר</option>
                        </select2>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-3">
                    <div class="add_new_row_col1 desk-hide">חומרה*</div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block">
                        <select2
                          name=""
                          dir="rtl"
                          v-model="material_sensitivity_info.severity"
                        >
                          <option value="">בחר חומרה</option>
                          <option>קלה</option>
                          <option>בינוני</option>
                          <option>קשה</option>
                          <option>הלם</option>
                          <option>בספק</option>
                        </select2>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-3">
                    <div class="add_new_row_col1 desk-hide">
                      שם חומר (בעברית)*
                    </div>
                    <div class="add_new_row_col2">
                      <div class="input-opacity desk-block relative">
                        <div
                          v-show="material_sensitivity_info.name !== ''"
                          @click="material_sensitivity_info.name = ''"
                          class="surg-clear-btn"
                          :class="{ 'btn-mobile': isMobile }"
                        >
                          X
                        </div>
                        <multiselect
                          placeholder=""
                          v-model="material_sensitivity_info.name"
                          @search-change="
                            onSearch($event, 'material_sensitivity')
                          "
                          :options="material_sensitivity"
                          :searchable="true"
                          :allow-empty="false"
                          :options-limit="limit.material_sensitivity"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="add_new_row flex surg_list-5">
                    <div class="add_new_row_col1 w-100 desk-hide">הערות</div>
                    <div class="input_area_opcity">
                      <textarea
                        v-model="material_sensitivity_info.notes"
                        placeholder="פירוט.."
                        autocomplete="off"
                      ></textarea>
                    </div>
                  </div>
                  <ActionsMsgRow
                    :errMsg="errorMessages.material"
                    :isOnEdit="material_sensitivity_info_edit"
                    @addBlock="addBlock('material')"
                    @removeSelectedBlock="
                      resetRow(
                        'material_sensitivity_info',
                        'material_sensitivity_info_edit'
                      )
                    "
                  />
                </div>
              </div>
            </div>
            <!-- End Stage 3  -->

            <!-- Stage 4 -->
            <div ref="surgHelpers">
              <AnalysisTools
                v-if="stage === 4 || isMobile"
                :surg="surg"
                :isMobile="isMobile"
                :insurance_surgery_temp="insurance_surgery_temp"
                :insurance_type="
                  isPayTypeCareService ? payType : surg.insurance_type
                "
                :editSurgery="editSurgery ? true : false"
              />
            </div>

            <div class="error-message center" v-if="serverError">
              {{ serverError }}
            </div>
            <div v-if="stage !== 4 && !isMobile" class="form_submit center">
              <button class="bt_blue" @click.prevent="onNextStage">
                הבא
                <vue-loaders-ball-clip-rotate
                  v-show="isLoading"
                  color="white"
                  scale="1.2"
                  style="position: relative;top: 5px;"
                ></vue-loaders-ball-clip-rotate>
              </button>
            </div>
            <div v-show="stage === 4 || isMobile" class="form_submit center">
              <button type="submit" class="bt_blue">המשך לאישור</button>
            </div>
          </section>
        </form>
      </ValidationObserver>
    </div>
    <SurgApprove
      v-show="isSurgConfirm"
      :surgery="surgToApprove"
      :files="surg.files"
      :filesType="filesType"
      :beforeEditFiles="beforeEditFiles"
      :isAfterEdit="editSurgery ? true : false"
      @approveGoBack="
        isSurgConfirm = false;
        stage = 4;
      "
    />
  </div>
</template>

<script>
import SurgSidesErr from "@/components/Popups/SurgSidesErr.vue";
import Error from "@/components/Popups/Error";
import { mapActions, mapState, mapGetters } from "vuex";
import SurgApprove from "./SurgerySummary/SurgApprove.vue";
import Cleave from "vue-cleave-component";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import surgerySelect from "../../../mixins/surgerySelect.json";
import { getHash } from "../../../utilities/hash.js";
import {
  insuranceQuestions,
  getFullCareServices
} from "../../../utilities/surgery-questions.js";
import SelectedSurgeryInfo from "@/components/Dashboard/Surgery/AddSurgery/SelectedSurgeryInfo.vue";
// import InsuranceSurgeryInfo from "@/components/Dashboard/Surgery/AddSurgery/InsuranceSurgeryInfo.vue";
import CurrentDiagnosisInfo from "@/components/Dashboard/Surgery/AddSurgery/CurrentDiagnosisInfo.vue";
import PastDiagnosisInfo from "@/components/Dashboard/Surgery/AddSurgery/PastDiagnosisInfo.vue";
import MedicationSensitivityInfo from "@/components/Dashboard/Surgery/AddSurgery/MedicationSensitivityInfo.vue";
import MaterialSensitivityInfo from "@/components/Dashboard/Surgery/AddSurgery/MaterialSensitivityInfo.vue";
import ActionsMsgRow from "@/components/Dashboard/Surgery/AddSurgery/ActionsMsgRow.vue";
import MobileHeader from "@/components/Dashboard/Surgery/AddSurgery/MobileHeader.vue";
import DesktopHeader from "@/components/Dashboard/Surgery/AddSurgery/DesktopHeader.vue";
import Tags from "@/components/Dashboard/Surgery/AddSurgery/Tags.vue";
import PatientDetails from "./AddSurgery/PatientDetails.vue";
import AnalysisTools from "./AddSurgery/AnalysisTools.vue";
import NewFeature from "@/components/Popups/NewFeature";

var indicator = document.createElement("div");
indicator.className = "state-indicator";
document.body.appendChild(indicator);

export default {
  name: "SurgAdd",
  props: {
    editSurgery: {
      default: () => null
    }
  },
  data() {
    return {
      insuranceQuestions,
      surgerySelect,
      options: {
        time: true,
        timePattern: ["h", "m"]
      },
      isOnEditRow: false,
      editRow: {
        surgery: null,
        insurance: null,
        diagnosis: null,
        past_diagnosis: null,
        medication: null,
        material: null
      },
      beforeEditFiles: [],
      surgToApprove: null,
      isSurgConfirm: false,
      isInsuranceType: false,
      isHealty: false,
      stage: 2,
      code_query: "",
      serverError: "",
      surg_info: {
        is_primary: "primary",
        side: "",
        // category: "",
        code_name_hospital: "",
        code_name_clinical: "",
        duration: "",
        default_surgery_duration: ""
      },
      insurance_info: {
        // category: "",
        code: "",
        notes: ""
      },
      past_diagnosis: {
        side: "",
        diagnosis_number: "",
        diagnosis_name: "",
        notice: ""
      },
      errorMessages: {
        surgery: {
          show: false,
          msg: "יש למלא את כל השדות"
        },
        insurance: {
          show: false,
          msg: "יש למלא את כל השדות"
        },
        diagnosis: {
          show: false,
          msg: "יש למלא את כל השדות"
        },
        past_diagnosis: {
          show: false,
          msg: "יש למלא את כל השדות"
        },
        medication: {
          show: false,
          msg: "יש למלא את כל השדות"
        },
        material: {
          show: false,
          msg: "יש למלא את כל השדות"
        }
      },
      diagnosis_info: {
        side: "",
        code: "",
        name: "",
        notes: ""
      },
      medication_sensitivity_info: {
        reaction: "",
        severity: "",
        name: "",
        notes: ""
      },
      material_sensitivity_info: {
        reaction: "",
        severity: "",
        name: "",
        notes: ""
      },
      surgery_categories: [],
      surgery_codes: [],
      surgery_codes_auto: [],
      surgery_codes_clinic: [],
      surgery_codes_clinic_auto: [],
      current_diagnosis: [],
      past_diagnosis_options: [],
      medication_sensitivity: [],
      material_sensitivity: [],
      insurance_types: surgerySelect.insurance_types,
      insurance_surgery_categories: [],
      insurance_surgery_codes: [],
      material_sensitivity_info_edit: false,
      medication_sensitivity_info_edit: false,
      surge_info_edit: false,
      diagnosis_info_edit: false,
      insurance_info_edit: false,
      past_diagnosis_edit: false,
      insurance_surgery_temp: [],
      surg: {
        id_num: this.$store.state.surg_patient.id_num,
        first_name: this.$store.state.surg_patient.first_name,
        last_name: this.$store.state.surg_patient.last_name,
        birth_date: null,
        parent_name: this.$store.state.surg_patient.apotropos || "",
        parental_status: this.$store.state.surg_patient.parental_status || "",
        phone: this.$store.state.surg_patient.phone || "",
        phone2: this.$store.state.surg_patient.second_phone || "",
        lang: "",
        gender: this.$store.state.surg_patient.gender || "",
        email: this.$store.state.surg_patient.email || "",
        selected_surgery: [],
        initial_selected_surgery: [],
        treatment_history: "",
        current_diagnosis: [],
        past_diagnosis: [],
        background_diagnosis: "",
        phisycal_check: "",
        no_drug_sens: false,
        no_material_sens: false,
        medication_sensitivity: [],
        material_sensitivity: [],
        insurance_surgery: [],
        assistant: "",
        assistant_name: "",
        hospitalization: "",
        anesthesia: "",
        xray_type: "",
        select_frozen_cut: "",
        requests: {
          monitoring_request: false,
          blood: false,
          icu: false,
          tee_request: false,
          navigation_request: false
        },
        doctor_fee: "",
        insurance_type: "",
        resources: "",
        notes: "",
        files: [],
        isInsuranceCompany: "",
        insuranceCompany: "",
        handle_insurance_claim_by_hmc: "",
        confirm_agreement: "",
        pre_surgery_override: false
      },
      doctorHistory: null,
      limit: {
        current_surgery: 10,
        current_procedure: 10,
        current_diagnosis: 10,
        past_diagnosis: 10,
        medication_sensitivity: 10,
        material_sensitivity: 10,
        current_insurance: 10
      },
      filesType: "medicaldocuments-patient",
      payType: "",
      disabledByAutocomplete: {
        clinical: false,
        hospital: false
      },
      isPayRequired: "",
      isInsuranceRowsLoading: false,
      isLoading: false,
      // Toggle states for all collapsible sections (Vue-controlled)
      toggleStates: {
        selectedSurgery: true, // starts open
        insuranceType: true, // starts open
        insuranceSurg: true, // starts open (desktop), will be set in mounted for mobile
        treatmentHistory: false, // starts closed
        currentDiagnosis: false, // starts closed
        pastDiagnosis: true, // starts open (desktop)
        physicalCheck: true, // starts open (desktop)
        medicationSensitivity: false, // starts closed
        materialSensitivity: false // starts closed
      }
    };
  },
  async mounted() {
    // Set toggle states for mobile - close sections that are open by default on desktop
    if (this.isMobile) {
      this.toggleStates.insuranceSurg = false;
      this.toggleStates.pastDiagnosis = false;
      this.toggleStates.physicalCheck = false;
    }

    if (
      this.$store.state.surg_patient.gender === "male" ||
      this.$store.state.surg_patient.gender === "זכר"
    ) {
      this.surg.gender = "male";
    } else if (
      this.$store.state.surg_patient.gender === "female" ||
      this.$store.state.surg_patient.gender === "נקבה"
    ) {
      this.surg.gender = "female";
    } else {
      this.surg.gender = "";
    }
    // history
    this.getHistory();

    this.$API.getTypehead("current_surgery_category").then(res => {
      this.surgery_categories = res;
    });

    // get insuarnce_types
    // const resInsuarnce = await this.$API.getTypehead("insuarnce_types");
    // let filtred = [];
    // resInsuarnce.forEach(item => {
    //   const find = filtred.find(i => i.insurance_code == item.insurance_code);
    //   if (!find) filtred.push(item);
    // });
    // this.insurance_types = filtred;

    // birth_date format
    if (this.$store.state.surg_patient.birth_date) {
      this.surg.birth_date = this.$moment(
        this.$store.state.surg_patient.birth_date,
        "DD-MM-YYYY"
      ).format("DD/MM/YYYY");
    }

    // For Edit surg
    if (this.editSurgery) {
      this.surg = JSON.parse(JSON.stringify(this.editSurgery));
      if (this.editSurgery.payType) this.payType = this.editSurgery.payType;
      if (this.payType === "חברת ביטוח") {
        this.isPayRequired = this.surg.doctor_fee ? "true" : "false";
      }

      this.surg.initial_selected_surgery = JSON.parse(
        JSON.stringify(this.surg.selected_surgery)
      );
      // checkbox past_diagnosis
      this.isHealty = this.editSurgery.checkbox_past_diagnosis;
      if (this.isHealty) this.surg.background_diagnosis = "healthy";
      // surg.insurance_type
      this.insurance_surgery_temp = JSON.parse(
        JSON.stringify(this.surg.selected_surgery)
      );
      this.getDataAfterPayTypeChanged(this.surg.insurance_type);
      this.surg_info.is_primary = false;
      setTimeout(() => {
        this.surg.initial_selected_surgery = this.surg.initial_selected_surgery.map(
          (order, j) => {
            return {
              ...this.getFormattedOrders([order], j)[0],
              id: order.id,
              additionalInfo: order.additionalInfo
            };
          }
        );
      }, 1000);

      // Open toggle states for sections with content when editing
      this.setToggleStatesForEdit();
    }

    this.$root.$on("changedSpecialInsuranceCode", async ev => {
      if (!ev.value) return;
      if (ev.value === "חברת ביטוח") ev.value = this.surg.insuranceCompany;
      const selectedInsurance = this.insurance_types.find(
        t => t.insurance_name === ev.value
      );
      if (!selectedInsurance) return;
      await new Promise(resolve => setTimeout(resolve, 800));
      if (this.insurance_surgery_temp[ev.index]) {
        this.insurance_surgery_temp[ev.index].newSpecialInsuranceCode =
          selectedInsurance.insurance_name === "כללית מושלם" ? false : true;
      }
      const id = parseInt(selectedInsurance.insurance_code);
      this.setInsuranceCode(ev.index, id);
    });
  },
  watch: {
    editSurgery(val) {
      this.surg = val;
    },
    "surg.confirm_agreement"(val) {
      if (val !== "true") {
        const index = this.surg.files.findIndex(
          file => file.type === "clinic-confirm-agreement"
        );
        if (index !== -1) {
          this.surg.files[index].files = [];
        }
      }

      // Don't remove - pointer error
      this.surg = { ...this.surg };
    },
    "surg.isInsuranceCompany"(val, prevVal) {
      if (val == prevVal || !prevVal) return;
      this.payType = "";
      this.surg.doctor_fee = "";
      this.surg.insuranceCompany = "";
      this.surg.handle_insurance_claim_by_hmc = "";
      const found = this.insurance_surgery_temp.find(
        s => s && s.code_name_hospital === "1 > RHINOPLASTY"
      );
      if (found) {
        found.insurance_type = "";
        found.insurance_surgery_codes = [];
      }
    },
    payType(val) {
      if (!val || this.isPayTypeCareService) this.surg.doctor_fee = "";
      if (val !== "חברת ביטוח") {
        this.isPayRequired = "";
        this.surg.handle_insurance_claim_by_hmc = "";
      }
      if (val !== "חברת ביטוח" && val !== "פרטי") {
        this.surg.doctor_fee = "";
      }
      this.getDataAfterPayTypeChanged(val);
    },
    async "surg_info.code_name_hospital"(val) {
      if (!val) {
        this.disabledByAutocomplete.clinical = false;
        this.surg_info.duration = "";
        if (
          this.insurance_surgery_temp?.length !==
          this.surg.selected_surgery?.length
        ) {
          if (this.insurance_surgery_temp[this.editRow.surgery]) {
            // On edit
            this.insurance_surgery_temp[
              this.editRow.surgery
            ].code_name_hospital = "";
          } else {
            // New
            this.insurance_surgery_temp.pop();
          }
        }
        return;
      }

      let newSpecialInsuranceCode = false;
      let insuranceSurgeryIndex = this.insurance_surgery_temp.length;
      if (this.insurance_surgery_temp[this.editRow.surgery]) {
        // On edit
        insuranceSurgeryIndex = this.editRow.surgery;
        this.insurance_surgery_temp[this.editRow.surgery] = {
          ...this.insurance_surgery_temp[this.editRow.surgery],
          code_name_hospital: val
        };
      } else {
        // New
        this.insurance_surgery_temp.push({ code_name_hospital: val });
        if (val === "1 > RHINOPLASTY") {
          newSpecialInsuranceCode = true;
          const lastIndex = this.insurance_surgery_temp.length - 1;
          this.insurance_surgery_temp[lastIndex].insurance_type = "פרטי";
          this.insurance_surgery_temp[lastIndex].newSpecialInsuranceCode = true;
        }
      }
      const selectedInsurance = this.getSelectedInsurance(
        newSpecialInsuranceCode ? "פרטי" : this.payType
      );

      if (selectedInsurance) {
        const id = parseInt(selectedInsurance.insurance_code);
        await this.setInsuranceCode(insuranceSurgeryIndex, id);
      }

      this.$API
        .getTypehead(
          "surgery_duration",
          null,
          null,
          this.activeDoctor.license,
          val
        )
        .then(res => {
          if (res) {
            const time = this.$moment(res, "H:mm").format("HH:mm");
            this.surg_info.default_surgery_duration = time;
            this.surg_info.duration = time;
            this.$refs.surgform.reset();
          }
        });
      if (this.surg_info.code_name_clinical && !this.isOnEditRow) return;
      const code = val.split(" > ")[0].replace(/\s/g, "");
      this.$API
        .getAutocompleteSurgCode("tafnit_to_chameleon", code)
        .then(res => {
          this.surgery_codes_clinic_auto = [];
          this.disabledByAutocomplete.clinical = false;
          if (res && res.length) {
            if (this.isOnEditRow) {
              if (
                res.length == 1 &&
                res[0].name == this.surg_info.code_name_clinical
              ) {
                this.disabledByAutocomplete.clinical = true;
              }
              return;
            }
            if (res.length == 1) {
              this.surg_info.code_name_clinical = res[0].name;
              this.disabledByAutocomplete.clinical = true;
            } else {
              const tmp = res.map(item => item.name);
              this.surgery_codes_clinic_auto = tmp;
            }
          }
        });
    },
    "surg_info.code_name_clinical"(val) {
      if (!val || this.surg_info.code_name_hospital) {
        this.disabledByAutocomplete.hospital = false;
        return;
      }
      const code = val.split(" > ")[0].replace(/\s/g, "");
      this.$API
        .getAutocompleteSurgCode("chameleon_to_tafnit", code)
        .then(res => {
          this.surgery_codes_auto = [];
          this.disabledByAutocomplete.hospital = false;
          if (res && res.length) {
            if (res.length == 1) {
              this.surg_info.code_name_hospital = res[0].name;
              this.disabledByAutocomplete.hospital = true;
            } else {
              const tmp = res.map(item => item.name);
              this.surgery_codes_auto = tmp;
            }
          }
        });
    },
    "surg_info.duration"(val) {
      if (!val) this.surg_info.duration = "HH:mm";
    },
    "surg.no_drug_sens"(value) {
      if (value) this.surg.medication_sensitivity = [];
    },
    "surg.no_material_sens"(value) {
      if (value) this.surg.material_sensitivity = [];
    },
    // "surg_info.category"(val) {
    //   // reset
    //   this.surgery_codes = [];
    //   this.surgery_codes_auto = [];
    //   this.surgery_codes_clinic = [];
    //   this.surgery_codes_clinic_auto = [];
    //   if (!this.isOnEditRow) {
    //     this.surg_info.code_name_clinical = "";
    //     this.surg_info.code_name_hospital = "";
    //   }

    //   if (val) {
    //     // api with category
    //     this.$API.getTypehead("current_surgery", parseInt(val)).then(res => {
    //       const tmp = res.map(r => r.surgery_eng_name);
    //       this.surgery_codes = this.getTypeheadHistory(tmp, "current_surgery");
    //     });

    //     this.$API.getTypehead("current_procedure", parseInt(val)).then(res => {
    //       const map = res.map(r => r.procedure);
    //       const tmp = [...new Set(map)];
    //       this.surgery_codes_clinic = this.getTypeheadHistory(
    //         tmp,
    //         "current_procedure"
    //       );
    //     });
    //   } else {
    //     // api witout category
    //     this.$API.getTypehead("current_surgery").then(res => {
    //       const tmp = res.map(r => r.surgery_eng_name);
    //       this.surgery_codes = this.getTypeheadHistory(tmp, "current_surgery");
    //     });

    //     this.$API.getTypehead("current_procedure").then(res => {
    //       const map = res.map(r => r.procedure);
    //       const tmp = [...new Set(map)];
    //       this.surgery_codes_clinic = this.getTypeheadHistory(
    //         tmp,
    //         "current_procedure"
    //       );
    //     });
    //   }
    // },
    "past_diagnosis.diagnosis_name"(val) {
      this.past_diagnosis.diagnosis_number = val.substring(0, val.indexOf(" "));
    },
    "diagnosis_info.name"(val) {
      this.diagnosis_info.code = val.substring(0, val.indexOf(" "));
    },
    "surg.assistant"(val) {
      if (val != "מביא אסיסטנט") this.surg.assistant_name = "";
    },
    "surg.insurance_type"(val, prevVal) {
      if (val == prevVal || !prevVal) return;
      this.isInsuranceType = false;
      this.payType = "";
      this.surg.doctor_fee = "";
      this.surg.handle_insurance_claim_by_hmc = "";
    },
    activeDoctor() {
      this.getHistory();
    }
  },
  computed: {
    ...mapState(["saveSurgery", "user_passport"]),
    ...mapGetters(["activeDoctor"]),
    isMobile() {
      return window && window.innerWidth < 1200 ? true : false;
    },
    payOptions() {
      const insuranceTypes = {
        כללית: this.insuranceQuestions.clalitOptions,
        מאוחדת: this.insuranceQuestions.meohedetOptions,
        מכבי: this.insuranceQuestions.macabiOptions,
        לאומית: this.insuranceQuestions.leumitOptions
      };

      let filteredPayOptions = insuranceTypes[this.surg.insurance_type] || [
        { text: "בחר", value: "" }
      ];

      let payOptions = this.insuranceQuestions.payOptions;

      if (this.surg.isInsuranceCompany === "false") {
        filteredPayOptions = filteredPayOptions.filter(
          item => item.value !== "חברת ביטוח"
        );
        payOptions = payOptions.filter(item => item.value !== "חברת ביטוח");
      }

      return [
        ...filteredPayOptions,
        ...(this.surg.insurance_type !== "כללית" ? payOptions : [])
        // { text: "אחר", value: "אחר" }
      ];
    },
    isPayTypeCareService() {
      const options = [
        "כללית מושלם",
        "מאוחדת שבן",
        // "לאומית שבן",
        "משרד הביטחון"
      ];
      return options.includes(this.payType);
    },
    isSelectedPrimarySurg() {
      if (!this.surg.selected_surgery?.length) return false;
      return this.surg.selected_surgery.find(s => s.is_primary) ? true : false;
    },
    foundSpecialInsuranceCode() {
      if (!Array.isArray(this.insurance_surgery_temp)) return null;

      const item = this.insurance_surgery_temp.find(s => s && s.insurance_type);
      if (!item) return null;

      const insurance =
        item.insurance_type === "חברת ביטוח"
          ? this.surg.insuranceCompany
          : item.insurance_type;

      return insurance;
    },
    isRHINOPLASTYSuregry() {
      if (!this.insurance_surgery_temp.length || this.payType !== "כללית מושלם")
        return false;
      const found = this.insurance_surgery_temp.find(
        s =>
          s &&
          s.code_name_hospital === "1 > RHINOPLASTY" &&
          s.insurance_type === "פרטי"
      );
      return found ? true : false;
    }
  },
  methods: {
    ...mapActions(["SET_SURGERY"]),
    getFullCareServices,
    onCleave(ev) {
      if (ev) {
        this.surg_info.duration =
          ev.substring(0, 2) + ":" + ev.substring(2, ev.length);
      } else {
        this.surg_info.duration = ev;
      }
    },
    /**
     * Toggle a collapsible section by name
     * @param {string} sectionName - The key in toggleStates object
     */
    toggleSection(sectionName) {
      if (this.toggleStates.hasOwnProperty(sectionName)) {
        this.toggleStates[sectionName] = !this.toggleStates[sectionName];
      }
    },
    /**
     * Set toggle states to open for sections that have existing content
     * Used when editing a surgery to show filled sections by default
     */
    setToggleStatesForEdit() {
      if (this.surg.treatment_history) {
        this.toggleStates.treatmentHistory = true;
      }
      if (
        this.surg.current_diagnosis &&
        this.surg.current_diagnosis.length > 0
      ) {
        this.toggleStates.currentDiagnosis = true;
      }
      if (
        this.surg.background_diagnosis &&
        this.surg.background_diagnosis.length > 0
      ) {
        this.toggleStates.pastDiagnosis = true;
      }
      if (this.surg.physical_check_up) {
        this.toggleStates.physicalCheck = true;
      }
      if (
        this.surg.medication_sensitivity &&
        this.surg.medication_sensitivity.length > 0
      ) {
        this.toggleStates.medicationSensitivity = true;
      }
      if (
        this.surg.material_sensitivity &&
        this.surg.material_sensitivity.length > 0
      ) {
        this.toggleStates.materialSensitivity = true;
      }
    },
    // Backwards compatibility - will be removed after full migration
    toggleTreatmentHistory() {
      this.toggleSection("treatmentHistory");
    },
    onPrevStage() {
      this.$refs.surgform.reset();
      for (const key in this.errorMessages) {
        this.errorMessages[key].show = false;
      }
      if (this.stage === 2) {
        this.$router.push("surg-add");
      } else if (this.stage > 2) {
        this.stage--;
      }
    },
    async onNextStage() {
      if (this.stage === 3) await this.addBlockDefault();

      const res = await this.$refs.surgform.validate();
      const errors = this.$refs.surgform.errors;
      let elementScroll;

      if (this.stage === 3) {
        const insuranceRes = this.checkSelectedInsurance();
        if (insuranceRes) return;

        const sidesRes = this.checkSurgerySides();
        if (!sidesRes) {
          this.$modal.show(SurgSidesErr);
          return;
        }

        if (!this.isSelectedPrimarySurg && this.surg.selected_surgery.length) {
          this.surg.selected_surgery[0].is_primary = "primary";
        }

        if (!this.surg.selected_surgery?.length) {
          this.errorMessages.surgery.show = true;
          elementScroll = "selected_surgery";
        }

        if (
          errors.insurance_type?.length ||
          errors.isInsuranceCompany?.length ||
          errors.insuranceCompany?.length ||
          errors.payType?.length ||
          errors.insuranceClaim?.length ||
          errors.isPayRequired?.length
        ) {
          elementScroll = elementScroll || "insuranceType";
        }

        const insuranceErroes = Object.entries(errors)
          .filter(([key]) => key.includes("insuranceSurgeryCode"))
          .map(([, value]) => value);
        const isInsuranceErr = insuranceErroes.filter(i => i?.length);

        if (
          (this.isInsuranceType && this.errorMessages.insurance.show) ||
          isInsuranceErr?.length ||
          errors.specialInsuranceCode?.length
        ) {
          elementScroll = elementScroll || "insuranceSurg";
        }

        if (this.errorMessages.diagnosis.show) {
          elementScroll = elementScroll || "currentDiagnosis";
        }

        if (!this.isHealty && !this.surg.past_diagnosis?.length) {
          this.errorMessages.past_diagnosis.show = true;
          elementScroll = elementScroll || "past_diagnosis";
        }

        if (errors.phisycal_check?.length) {
          elementScroll = elementScroll || "phisycal_check";
        }

        if (this.errorMessages.medication.show) {
          elementScroll = elementScroll || "medication_sensitivity";
        }

        if (this.errorMessages.material.show) {
          elementScroll = elementScroll || "material_sensitivity";
        }
      }

      if (elementScroll) {
        const element = this.$refs[elementScroll];

        if (element?.offsetTop) {
          setTimeout(() => {
            window.scrollTo({
              top: element.offsetTop,
              left: 0,
              behavior: "smooth"
            });
          }, 100);
          return;
        }
      }

      if (
        (res && this.stage !== 3) ||
        (this.stage === 3 &&
          !errors.insurance_type?.length &&
          !errors.phisycal_check?.length)
      ) {
        if (this.stage === 3) {
          this.setSurgeryInsuranceDeatels();
          let success = true;
          if (this.editSurgery || this.surg.initial_selected_surgery.length) {
            success = await this.editSurgeryOrders();
          } else {
            success = await this.setSurgeryOrders();
          }
          if (!success) return;
        }
        this.stage++;
        window.scrollTo(0, 0);
      }
    },
    onHealty() {
      this.isHealty = !this.isHealty;
      if (this.isHealty) {
        this.surg.background_diagnosis = "healthy";
        this.surg.past_diagnosis = [];
        this.past_diagnosis = {
          side: "",
          diagnosis_number: "",
          diagnosis_name: "",
          notice: ""
        };
        // Close the section when marking as healthy (fields are not needed)
        this.toggleStates.pastDiagnosis = false;
      } else {
        this.surg.background_diagnosis = "";
        // Open the section when unmarking - user needs to fill in diagnoses
        this.toggleStates.pastDiagnosis = true;
      }
    },
    onPrimary() {
      if (this.surg_info.is_primary === "primary")
        this.surg_info.is_primary = "";
      else this.surg_info.is_primary = "primary";
    },
    async confirmSurg() {
      //this.$router.push({ name: "surg-confirm" });
      this.serverError = "";
      if (this.isMobile) await this.addBlockDefault();
      let res = await this.$refs.surgform.validate();
      if (this.isMobile) {
        const insuranceRes = this.checkSelectedInsurance();
        if (insuranceRes) return;

        const sidesRes = this.checkSurgerySides();
        if (!sidesRes) {
          this.$modal.show(SurgSidesErr);
          return;
        }

        const mobileValid = await this.errScroll(res);
        if (!mobileValid) return;
        this.setSurgeryInsuranceDeatels();
        let success = true;
        if (this.editSurgery || this.surg.initial_selected_surgery.length)
          success = await this.editSurgeryOrders();
        else success = await this.setSurgeryOrders();
        if (!success) return;
      }

      if (res) {
        let surgery_obj = {
          form_type: "modal",
          surgery_id: "",
          block_id: "",
          start_surgery: "",
          end_surgery: "",
          doctor_id: this.activeDoctor.id,
          passport: this.surg.id_num,
          first_name: this.surg.first_name,
          last_name: this.surg.last_name,
          birth_date: this.$moment(this.surg.birth_date, "DD/MM/YYYY").format(
            "DD-MM-YYYY"
          ),
          gender: this.surg.gender,
          phone: this.surg.phone,
          user_language: this.surg.lang,
          second_phone: this.surg.phone2,
          apotropos_name: this.surg.parent_name,
          parental_status: this.surg.parental_status,
          email: this.surg.email,
          current_surgery: [],
          indication: this.surg.treatment_history,
          current_diagnosis: [],
          checkbox_past_diagnosis: this.isHealty ? 1 : null,
          past_diagnosis: [],
          physical_examination: this.surg.phisycal_check,
          checkbox_medication_sensitivity: this.surg.no_drug_sens ? 1 : null,
          medication_sensitivity: [],
          checkbox_material_sensitivity: this.surg.no_material_sens ? 1 : null,
          material_sensitivity: [],
          insurance_surgery: [],
          insurance_name: "",
          secondary_insurance_name: "",
          doctor_fee: this.surg.doctor_fee || 0,
          assistant_status: this.surg.assistant,
          assistant_name: this.surg.assistant_name,
          hospitalization: this.surg.hospitalization,
          resources: this.surg.resources,
          notes: this.surg.notes,
          frozen_cut: this.surg.select_frozen_cut,
          xray_type: this.surg.xray_type,
          monitoring_request: this.surg.requests.monitoring_request ? "כן" : "",
          blood: this.surg.requests.blood ? "כן" : "",
          icu: this.surg.requests.icu ? "כן" : "",
          tee_request: this.surg.requests.tee_request ? "כן" : "",
          navigation_request: this.surg.requests.navigation_request ? "כן" : "",
          anesthesia: this.surg.anesthesia,
          handle_insurance_claim_by_hmc: this.surg
            .handle_insurance_claim_by_hmc,
          pre_surgery_override: this.surg.pre_surgery_override
        };

        const passport_type = this.editSurgery
          ? this.editSurgery.passport_type
          : this.$store.state.surg_patient.passport_type;
        if (passport_type) surgery_obj.passport_type = passport_type;

        if (this.isPayTypeCareService || this.payType == "") {
          surgery_obj.insurance_name = this.surg.insurance_type;
          if (this.isPayTypeCareService) {
            surgery_obj.insurance_name = this.payType;
          }
          surgery_obj.secondary_insurance_name = this.surg.insuranceCompany;

          if (this.isPayTypeCareService && this.payType === "משרד הביטחון") {
            surgery_obj.secondary_insurance_name = this.surg.insurance_type;
          }

          if (
            this.payType === "כללית מושלם" &&
            this.foundSpecialInsuranceCode &&
            this.insurance_surgery_temp.length === 1
          ) {
            surgery_obj.secondary_insurance_name = surgery_obj.insurance_name;
            surgery_obj.insurance_name = this.foundSpecialInsuranceCode;
          }
        } else if (this.payType == "חברת ביטוח") {
          surgery_obj.insurance_name = this.surg.insuranceCompany;
          surgery_obj.secondary_insurance_name = this.getFullCareServices(
            this.surg.insurance_type
          );
        } else {
          surgery_obj.insurance_name = this.payType;
          if (this.surg.insurance_type == "ללא קופה") {
            surgery_obj.secondary_insurance_name = this.surg.insuranceCompany;
          } else {
            if (this.payType == "מכבי" || this.payType == "לאומית") {
              surgery_obj.secondary_insurance_name = this.surg.insuranceCompany;
            } else {
              surgery_obj.secondary_insurance_name = this.getFullCareServices(
                this.surg.insurance_type
              );
            }
          }
        }

        this.surg.selected_surgery.map(s => {
          surgery_obj.current_surgery.push({
            // surgery_category: s.category,
            is_primary: s.is_primary,
            procedure: s.code_name_clinical,
            surgery_name: s.code_name_hospital,
            surgery_duration: s.duration,
            default_surgery_duration: s.default_surgery_duration,
            side: s.side
          });
        });
        this.surg.current_diagnosis.map(diagnosis => {
          surgery_obj.current_diagnosis.push({
            side: diagnosis.side,
            diagnosis_number: diagnosis.code,
            diagnosis_name: diagnosis.name,
            notice: diagnosis.notes
          });
        });
        this.surg.past_diagnosis.map(diagnosis => {
          surgery_obj.past_diagnosis.push({
            side: diagnosis.side,
            diagnosis_number: diagnosis.diagnosis_number,
            diagnosis_name: diagnosis.diagnosis_name,
            notice: diagnosis.notice
          });
        });
        this.surg.medication_sensitivity.map(sens => {
          surgery_obj.medication_sensitivity.push({
            response: sens.reaction,
            severity: sens.severity,
            medication: sens.name,
            notice: sens.notes
          });
        });
        this.surg.material_sensitivity.map(material => {
          surgery_obj.material_sensitivity.push({
            response: material.reaction,
            severity: material.severity,
            material_name: material.name,
            notice: material.notes
          });
        });
        this.insurance_surgery_temp.map(insurance => {
          let type = insurance?.insurance_type;

          if (!type) {
            type = this.isPayTypeCareService
              ? this.payType
              : this.surg.insurance_type;
          }

          surgery_obj.insurance_surgery.push({
            insurance: type,
            // surgery_category: insurance.category,
            surgery_name: insurance?.code,
            notice: insurance?.notes
          });
        });

        // If it is company insurance delete insurance_surgery
        if (!this.isPayTypeCareService) surgery_obj.insurance_surgery = [];

        // surgery_obj.surgery_id = "";
        if (this.editSurgery) {
          surgery_obj.surgery_id = this.$route.params.id;
        }
        this.surgToApprove = surgery_obj;
        this.isSurgConfirm = true;
        this.$refs.surgform.reset();
        for (const key in this.errorMessages) {
          this.errorMessages[key].show = false;
        }
        // this.SET_SURGERY(surgery_obj);
        // this.$router.push("/surg-confirm");
      } else {
        const errors = this.$refs.surgform.errors;
        let fileErr;
        for (const key in errors) {
          if (errors[key].length > 0 && key.includes("file")) {
            fileErr = key;
            break;
          }
        }

        let element =
          document.querySelector(`#${fileErr}`) ||
          document.querySelector("#files-container");

        if (fileErr && element?.offsetTop) {
          window.scrollTo({
            top: element?.offsetTop,
            behavior: "smooth"
          });
        }
      }
    },
    getCategoryNameByCode(code) {
      let find = this.surgery_categories.find(
        cat => cat.current_surgery_category_code == code
      );
      if (typeof find != "undefined") {
        return find.current_surgery_category_name;
      }
      return "";
    },
    getInsuranceCategoryNameByCode(code) {
      let find = this.insurance_surgery_categories.find(
        cat => cat.insurance_category_code == code
      );
      if (find) return find.insurance_category_name;
      return "";
    },
    validateObjectData(object) {
      let flag = true;
      for (const key in object) {
        if (key == "duration" && object[key] == "HH:mm") {
          flag = false;
        }
        if (
          key !== "notes" &&
          key !== "notice" &&
          // key !== "category" &&
          key !== "side" &&
          object[key] == "" &&
          key != "is_primary"
        ) {
          flag = false;
        }
      }
      return flag;
    },
    async addBlock(block_type) {
      const isAddFromEdit = this.editRow[block_type] != null;
      if (typeof block_type == "undefined" || !block_type) return;
      let object = {};
      for (const key in this.errorMessages) {
        this.errorMessages[key].show = false;
      }
      this.surge_info_edit = this.material_sensitivity_info_edit = this.medication_sensitivity_info_edit = this.diagnosis_info_edit = this.insurance_info_edit = false;
      switch (block_type) {
        case "surgery":
          const res = await this.$refs.end_time.validate();
          if (res && res.valid) {
            object = Object.assign({}, this.surg_info);
            if (!this.validateObjectData(object)) {
              this.errorMessages.surgery.show = true;
              break;
            }
            // remove primary from other surgeries
            if (object.is_primary) {
              this.surg.selected_surgery.forEach(s => (s.is_primary = ""));
            }
            this.surg.selected_surgery.splice(
              isAddFromEdit
                ? this.editRow[block_type]
                : this.surg.selected_surgery.length,
              0,
              object
            );
            for (const key in this.surg_info) {
              this.surg_info[key] = "";
            }
          } else {
            this.errorMessages.surgery.show = true;
          }
          break;
        case "insurance":
          object = Object.assign({}, this.insurance_info);
          if (!this.validateObjectData(object)) {
            this.errorMessages.insurance.show = true;
            break;
          }
          this.surg.insurance_surgery.splice(
            isAddFromEdit
              ? this.editRow[block_type]
              : this.surg.insurance_surgery.length,
            0,
            object
          );
          for (const key in this.insurance_info) {
            this.insurance_info[key] = "";
          }
          break;
        case "diagnosis":
          object = Object.assign({}, this.diagnosis_info);
          if (!this.validateObjectData(object)) {
            if (!this.isOnEditRow) this.errorMessages.diagnosis.show = true;
            break;
          }
          this.surg.current_diagnosis.splice(
            isAddFromEdit
              ? this.editRow[block_type]
              : this.surg.current_diagnosis.length,
            0,
            object
          );
          for (const key in this.diagnosis_info) {
            this.diagnosis_info[key] = "";
          }
          break;
        case "past_diagnosis":
          object = Object.assign({}, this.past_diagnosis);
          if (!this.validateObjectData(object)) {
            this.errorMessages.past_diagnosis.show = true;
            break;
          }
          this.surg.past_diagnosis.splice(
            isAddFromEdit
              ? this.editRow[block_type]
              : this.surg.past_diagnosis.length,
            0,
            object
          );
          for (const key in this.past_diagnosis) {
            this.past_diagnosis[key] = "";
          }
          break;
        case "medication":
          object = Object.assign({}, this.medication_sensitivity_info);
          if (!this.validateObjectData(object)) {
            if (!this.isOnEditRow) this.errorMessages.medication.show = true;
            break;
          }
          this.surg.medication_sensitivity.splice(
            isAddFromEdit
              ? this.editRow[block_type]
              : this.surg.medication_sensitivity.length,
            0,
            object
          );
          for (const key in this.medication_sensitivity_info) {
            this.medication_sensitivity_info[key] = "";
          }
          break;
        case "material":
          object = Object.assign({}, this.material_sensitivity_info);
          if (!this.validateObjectData(object)) {
            if (!this.isOnEditRow) this.errorMessages.material.show = true;
            break;
          }
          this.surg.material_sensitivity.splice(
            isAddFromEdit
              ? this.editRow[block_type]
              : this.surg.material_sensitivity.length,
            0,
            object
          );
          for (const key in this.material_sensitivity_info) {
            this.material_sensitivity_info[key] = "";
          }
          break;
      }
      if (isAddFromEdit) this.editRow[block_type] = null;
    },
    editSelectedBlock(block_type, index) {
      if (block_type == "surgery" && this.editRow[block_type]) {
        this.insurance_surgery_temp.splice(this.editRow[block_type], 1);
      }

      this.editRow[block_type] = index;
      this.isOnEditRow = true;
      let object = {};
      switch (block_type) {
        case "surgery":
          object = Object.assign({}, this.surg.selected_surgery[index]);
          this.surg.selected_surgery.splice(index, 1);
          this.surg_info = object;
          this.surge_info_edit = true;
          break;
        case "insurance":
          object = Object.assign({}, this.surg.insurance_surgery[index]);
          this.surg.insurance_surgery.splice(index, 1);
          this.insurance_info = object;
          this.insurance_info_edit = true;
          break;
        case "diagnosis":
          object = Object.assign({}, this.surg.current_diagnosis[index]);
          this.surg.current_diagnosis.splice(index, 1);
          this.diagnosis_info = object;
          this.diagnosis_info_edit = true;
          break;
        case "past_diagnosis":
          object = Object.assign({}, this.surg.past_diagnosis[index]);
          this.surg.past_diagnosis.splice(index, 1);
          this.past_diagnosis = object;
          this.past_diagnosis_edit = true;
          break;
        case "medication":
          object = Object.assign({}, this.surg.medication_sensitivity[index]);
          this.surg.medication_sensitivity.splice(index, 1);
          this.medication_sensitivity_info = object;
          this.medication_sensitivity_info_edit = true;
          break;
        case "material":
          object = Object.assign({}, this.surg.material_sensitivity[index]);
          this.surg.material_sensitivity.splice(index, 1);
          this.material_sensitivity_info = object;
          this.material_sensitivity_info_edit = true;
          break;
      }
      setTimeout(() => {
        this.isOnEditRow = false;
      }, 500);
    },
    removeSelectedBlock(block_type, index) {
      if (this.editRow[block_type] && index < this.editRow[block_type]) {
        this.editRow[block_type]--;
      }
      switch (block_type) {
        case "surgery":
          this.surg.selected_surgery.splice(index, 1);
          this.insurance_surgery_temp.splice(index, 1);
          break;
        case "insurance":
          this.surg.insurance_surgery.splice(index, 1);
          break;
        case "diagnosis":
          this.surg.current_diagnosis.splice(index, 1);
          break;
        case "past_diagnosis":
          this.surg.past_diagnosis.splice(index, 1);
          break;
        case "medication":
          this.surg.medication_sensitivity.splice(index, 1);
          break;
        case "material":
          this.surg.material_sensitivity.splice(index, 1);
          break;
      }
    },
    resetRow(type, isEdit) {
      if (!this[type]) return;
      for (const key in this[type]) {
        this[type][key] = "";
      }
      if (typeof this[isEdit] == "boolean") this[isEdit] = false;
    },
    goBackRoute() {
      const hashData = JSON.parse(localStorage.getItem("hashData"));
      if (!hashData || !Object.keys(hashData).length) {
        return this.$router.push("/dashboard/surgeries");
      }
      const hash = getHash({});
      return this.$router.push("/dashboard/surgeries#" + hash);
    },
    async errScroll(res = true) {
      const { errors } = this.$refs.surgform;
      const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

      const fieldsToCheck = [
        "birth_date",
        "first_name",
        "last_name",
        "phone",
        "gender"
      ];

      if (fieldsToCheck.some(field => errors[field]?.length)) {
        scrollToTop();
        return false;
      }

      const errorChecks = [
        {
          condition:
            !this.surg.selected_surgery?.length ||
            this.errorMessages.surgery.show,
          field: "selected_surgery"
        },
        {
          condition: [
            "insurance_type",
            "isInsuranceCompany",
            "insuranceCompany",
            "payType",
            "insuranceClaim",
            "isPayRequired"
          ].some(field => errors[field]?.length),
          field: "insuranceType"
        },
        {
          condition:
            (this.isInsuranceType && this.errorMessages.insurance.show) ||
            Object.entries(errors)
              .filter(([key]) => key.includes("insuranceSurgeryCode"))
              .some(([, value]) => value?.length) ||
            errors.specialInsuranceCode?.length,
          field: "insuranceSurg"
        },
        {
          condition: this.errorMessages.diagnosis.show,
          field: "currentDiagnosis"
        },
        {
          condition:
            !this.isHealty &&
            (!this.surg.past_diagnosis?.length ||
              this.errorMessages.past_diagnosis.show),
          field: "past_diagnosis"
        },
        { condition: errors.phisycal_check?.length, field: "phisycal_check" }
      ];

      if (!this.isSelectedPrimarySurg && this.surg.selected_surgery.length) {
        this.surg.selected_surgery[0].is_primary = "primary";
      }

      for (const { condition, field } of errorChecks) {
        if (condition) {
          this.errorMessages[field].show = true;
          const element = this.$refs[field];
          const top = this.isMobile
            ? element.offsetTop - 56
            : element.offsetTop;
          window.scrollTo({ top, behavior: "smooth" });
          return false;
        }
      }

      if (!res && this.isMobile) {
        let fileErr;
        for (const key in errors) {
          if (errors[key].length > 0 && key.includes("file")) {
            fileErr = key;
            break;
          }
        }

        let element =
          document.querySelector(`#${fileErr}`) ||
          document.querySelector("#files-container");

        if (fileErr && element?.offsetTop) {
          window.scrollTo({
            top: element?.offsetTop - 56,
            behavior: "smooth"
          });
          return false;
        }
      }

      return true;
    },
    async addBlockDefault() {
      for (const key in this.surg_info) {
        if (this.surg_info[key] && this.surg_info[key] != "HH:mm") {
          await this.addBlock("surgery");
          break;
        }
      }
      for (const key in this.insurance_info) {
        if (this.insurance_info[key]) {
          this.addBlock("insurance");
          break;
        }
      }
      for (const key in this.diagnosis_info) {
        if (this.diagnosis_info[key]) {
          this.addBlock("diagnosis");
          break;
        }
      }
      for (const key in this.past_diagnosis) {
        if (this.past_diagnosis[key]) {
          this.addBlock("past_diagnosis");
          break;
        }
      }
      for (const key in this.medication_sensitivity_info) {
        if (this.medication_sensitivity_info[key]) {
          this.addBlock("medication");
          break;
        }
      }
      for (const key in this.material_sensitivity_info) {
        if (this.material_sensitivity_info[key]) {
          this.addBlock("material");
          break;
        }
      }
    },
    async getHistory() {
      if (!this.activeDoctor || !this.activeDoctor.id) return;
      const resHistory = await this.$API.getDoctorHistory(this.activeDoctor.id);
      if (resHistory) this.doctorHistory = resHistory;

      this.$API.getTypehead("current_surgery").then(res => {
        const tmp = res.map(r => r.surgery_eng_name);
        this.surgery_codes = this.getTypeheadHistory(tmp, "current_surgery");
        this.surgery_codes = [...new Set(this.surgery_codes)];
      });

      this.$API.getTypehead("current_procedure").then(res => {
        const map = res.map(r => r.procedure);
        const tmp = [...new Set(map)];
        this.surgery_codes_clinic = this.getTypeheadHistory(
          tmp,
          "current_procedure"
        );
        this.surgery_codes_clinic = [...new Set(this.surgery_codes_clinic)];
      });

      this.$API.getTypehead("current_diagnosis").then(res => {
        const tmp = res.map(r => r.diagnosis);
        const tmp2 = [...tmp];
        this.current_diagnosis = this.getTypeheadHistory(
          tmp,
          "current_diagnosis"
        );
        this.past_diagnosis_options = this.getTypeheadHistory(
          tmp2,
          "past_diagnosis"
        );
        this.current_diagnosis = [...new Set(this.current_diagnosis)];
        this.past_diagnosis_options = [...new Set(this.past_diagnosis_options)];
      });

      this.$API.getTypehead("medication_sensitivity").then(res => {
        const tmp = res.map(r => r.name);
        this.medication_sensitivity = this.getTypeheadHistory(
          tmp,
          "medication_sensitivity"
        );
        this.medication_sensitivity = [...new Set(this.medication_sensitivity)];
      });

      this.$API.getTypehead("material_sensitivity").then(res => {
        const tmp = res.map(r => r.name);
        this.material_sensitivity = this.getTypeheadHistory(
          tmp,
          "material_sensitivity"
        );
        this.material_sensitivity = [...new Set(this.material_sensitivity)];
      });
    },
    getTypeheadHistory(resArr, type) {
      if (
        !this.doctorHistory ||
        !this.doctorHistory[type] ||
        !this.doctorHistory[type].length
      )
        return resArr;
      let historyArr = this.doctorHistory[type];
      historyArr = historyArr.filter(item => resArr.includes(item));
      if (historyArr && historyArr.length) this.limit[type] = historyArr.length;
      const filtred = resArr.filter(item => !historyArr.includes(item));
      return [...historyArr, ...filtred];
    },
    limitTypehead(type) {
      if (
        !this.doctorHistory ||
        !this.doctorHistory[type] ||
        !this.doctorHistory[type].length
      )
        return 10;
      return this.doctorHistory[type].length;
    },
    onSearch(ev, type) {
      if (ev) this.limit[type] = 10;
      else this.limit[type] = this.limitTypehead(type);
    },
    resetValue(type) {
      this.surg_info[type] = "";
      if (
        type == "code_name_hospital" &&
        this.disabledByAutocomplete.clinical
      ) {
        this.surg_info.code_name_clinical = "";
      }
      if (
        type == "code_name_clinical" &&
        this.disabledByAutocomplete.hospital
      ) {
        this.surg_info.code_name_hospital = "";
      }
    },
    isEnglish(text) {
      const englishRegex = /^[A-Za-z0-9\s!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]*$/;
      return englishRegex.test(text);
    },
    checkSelectedInsurance() {
      const isInsurance =
        this.isInsuranceType &&
        (this.isPayTypeCareService ||
          this.surg.isInsuranceCompany == "false") &&
        this.insurance_surgery_temp?.length;
      if (!isInsurance) return;

      const found = this.insurance_surgery_temp.find(
        s =>
          s &&
          !s.insurance_surgery_codes?.length &&
          s.code_name_hospital !== "1 > RHINOPLASTY"
      );
      if (found) {
        this.$modal.hideAll();
        this.$modal.show(NewFeature, {
          title: "רופא/ה יקר/ה",
          content: `לתשומת ליבך, לקוד הניתוח הנבחר לא קיים הסכם מול הקופה. יש ליצור קשר עם מוקד חדר ניתוח לקבלת עזרה`,
          buttonText: "הבנתי"
        });
      }
      return found;
    },
    checkSurgerySides() {
      if (!this.surg.selected_surgery || !this.surg.selected_surgery.length)
        return true;
      let groupedByCodeHospital = this.surg.selected_surgery.reduce(
        (acc, item) => {
          const key = item.code_name_hospital;
          acc[key] = acc[key] || [];
          acc[key].push(item);
          return acc;
        },
        {}
      );

      groupedByCodeHospital = Object.fromEntries(
        Object.entries(groupedByCodeHospital).filter(
          ([key, value]) => value.length > 1
        )
      );

      return Object.values(groupedByCodeHospital).every(items =>
        items.some(item => item.side === "") ? false : true
      );
    },
    getSelectedInsurance(payTypeValue = this.payType) {
      return this.insurance_types.find(t => t.insurance_name === payTypeValue);
    },
    async getDataAfterPayTypeChanged(payTypeValue) {
      this.isInsuranceType = false;

      const selectedInsurance = this.getSelectedInsurance(payTypeValue);
      if (!selectedInsurance) return;

      const uniqeInsurenceCodes = [
        "1240",
        "1249",
        "1239",
        "1007",
        "1017",
        "3027"
      ];
      if (!uniqeInsurenceCodes.includes(selectedInsurance.insurance_code))
        return;

      this.isInsuranceType = true;

      // Get by pay type insurance surgery categories
      const id = parseInt(selectedInsurance.insurance_code);
      const resCategories = await this.$API.getTypehead(
        "insurance_surgery_category",
        null,
        id
      );
      this.insurance_surgery_categories = resCategories.map(
        r => r.insurance_category_name
      );

      // Get by pay type insurance surgery codes
      const isInsurance =
        this.isInsuranceType &&
        (this.isPayTypeCareService ||
          this.surg.isInsuranceCompany == "false") &&
        this.insurance_surgery_temp?.length;

      // if (!this.insurance_surgery_temp?.length || !this.isPayTypeCareService)
      //   return;

      if (!isInsurance) return;

      for (let i = 0; i < this.insurance_surgery_temp.length; i++) {
        await this.setInsuranceCode(i, id);
      }
    },
    async setInsuranceCode(index, id) {
      const currentRow = this.insurance_surgery_temp[index];
      if (!currentRow?.code_name_hospital) return;

      this.isInsuranceRowsLoading = true;
      const [code, tafnit_name] = currentRow.code_name_hospital.split(" > ");

      let res = await this.$API.getTypehead(
        "insurance_surgery",
        null,
        id,
        null,
        null,
        code
      );
      //  If no results send other api call
      if (!res?.length) {
        res = await this.$API.getTypehead(
          "insurance_appointment",
          null,
          id,
          null,
          null,
          code
        );
      }
      currentRow.insurance_surgery_codes = res.map(r => r.surgery_name);

      if (currentRow.insurance_surgery_codes?.length === 1) {
        // If only one result set it
        currentRow.code = currentRow.insurance_surgery_codes[0];
      } else if (currentRow.code) {
        // If result already set check & set it
        const found = currentRow.insurance_surgery_codes.find(
          i => i == currentRow.code
        );
        if (!found) currentRow.code = "";
      }

      this.checkSelectedInsurance();

      this.insurance_surgery_temp = [...this.insurance_surgery_temp];
      this.isInsuranceRowsLoading = false;
    },
    setSurgeryInsuranceDeatels() {
      if (!this.insurance_surgery_temp?.length) return;

      this.insurance_surgery_temp = this.insurance_surgery_temp.map(
        (row, index) => {
          const selectedSurgery = this.surg.selected_surgery[index];
          if (!selectedSurgery) return;

          return {
            ...selectedSurgery,
            ...row
          };
        }
      );
    },
    getFormattedOrders(orders, index = undefined) {
      const type =
        this.payType == "חברת ביטוח"
          ? this.surg.insuranceCompany
          : this.payType;
      const selectedInsurance = this.insurance_types.find(
        t => t.insurance_name === type
      );

      const formatedOrders = orders.map((s, i) => {
        const [tafnit_code, tafnit_name] = s.code_name_hospital.split(" > ");
        const [icd9_code, icd9_name] = s.code_name_clinical.split(" > ");
        const duration_sec = this.$moment.duration(s.duration).asSeconds();
        const default_duration_sec = this.$moment
          .duration(s.default_surgery_duration)
          .asSeconds();
        const isSpecialCode =
          tafnit_code == 1 && this.payType === "כללית מושלם";

        let tmp = {
          tafnit_code,
          tafnit_name,
          icd9_code,
          icd9_name,
          duration_sec,
          default_duration_sec,
          body_side: s.side,
          insurance_id: selectedInsurance?.insurance_code,
          insurance_name: selectedInsurance?.insurance_name,
          item_code: null,
          name: null,
          medical_notes: null
        };
        if (s.is_primary) tmp.is_primary = "primary";

        // If exist selected insurance set to order all detailes
        if (this.insurance_surgery_temp?.length) {
          let insurance = this.insurance_surgery_temp[index];
          if (!insurance) insurance = this.insurance_surgery_temp[i];

          let type = this.payType;
          if (isSpecialCode && insurance) type = insurance.insurance_type;

          type = type === "חברת ביטוח" ? this.surg.insuranceCompany : type;

          const selectedInsurance = this.insurance_types.find(
            t => t.insurance_name === type
          );

          if (this.isInsuranceType && insurance?.code) {
            const [item_code, name] = insurance.code.split(" > ");
            tmp.item_code = item_code;
            tmp.name = name;
          }
          tmp.insurance_id = selectedInsurance?.insurance_code;
          tmp.insurance_name = selectedInsurance?.insurance_name;
          tmp.medical_notes = insurance?.notes;
        }

        return tmp;
      });

      return formatedOrders;
    },
    async callSurgeryOrdersAPI(params) {
      try {
        const res = await this.$API.scheduleSurgeryOrders(params);
        if (res && res.status === "ERROR") {
          this.$modal.show(Error, { title: res.message });
          return false;
        }
        return true;
      } catch (err) {
        let errorMessage = err.message || "התרחשה שגיאה";
        if (err.message === "לא התקבל קוד בית חולים או קוד ICD9") {
          errorMessage =
            "קוד בית חולים / ICD9 שגוי, יש לחזור ולבחור בקוד המתאים לפעולה.";
        }
        this.$modal.show(Error, { title: errorMessage });
        return false;
      }
    },
    async setSurgeryOrders(ordersToAdd = this.surg.selected_surgery) {
      if (!ordersToAdd.length) return true;

      this.isLoading = true;

      const formattedOrders = this.getFormattedOrders(ordersToAdd);
      const surgery_id = this.editSurgery
        ? this.$route.params.id
        : sessionStorage.getItem("temp_surgery");

      for (const order of formattedOrders) {
        const success = await this.callSurgeryOrdersAPI({
          action: "create",
          surgery_id,
          data: order
        });

        if (!success) {
          this.isLoading = false;
          return false;
        }
      }

      this.setInitialSurgeryOrders(surgery_id);
      this.isLoading = false;
      return true;
    },
    async editSurgeryOrders() {
      if (!this.surg.initial_selected_surgery?.length) return true;

      this.isLoading = true;

      const surgery_id = this.editSurgery
        ? this.$route.params.id
        : sessionStorage.getItem("temp_surgery");

      for (
        let index = 0;
        index < this.surg.initial_selected_surgery.length;
        index++
      ) {
        const order = this.surg.initial_selected_surgery[index];
        const currentOrder = this.surg.selected_surgery[index];
        const orderFormatted = { ...order };
        delete orderFormatted.id;

        // Remove order
        if (!currentOrder) {
          const success = await this.callSurgeryOrdersAPI({
            action: "remove",
            order_id: order.id,
            surgery_id,
            data: orderFormatted
          });
          if (!success) {
            this.isLoading = false;
            return false;
          }
          continue;
        }

        const currentOrderFormatted = this.getFormattedOrders(
          [currentOrder],
          index
        )[0];
        currentOrderFormatted.additionalInfo = order.additionalInfo;

        // No change
        if (
          JSON.stringify(orderFormatted) ===
          JSON.stringify(currentOrderFormatted)
        ) {
          continue;
        }

        let oredrToEdit = { ...currentOrderFormatted.additionalInfo };
        delete currentOrderFormatted.additionalInfo;
        oredrToEdit = { ...oredrToEdit, ...currentOrderFormatted };

        if (oredrToEdit.expiration_date) {
          oredrToEdit.expiration_date = this.$moment(
            oredrToEdit.expiration_date
          ).format("YYYY-MM-DD");
        }

        // Edit order
        const success = await this.callSurgeryOrdersAPI({
          action: "edit",
          order_id: order.id,
          surgery_id,
          data: oredrToEdit
        });
        if (!success) {
          this.isLoading = false;
          return false;
        }
      }

      // Add new orders
      if (
        this.surg.selected_surgery?.length >
        this.surg.initial_selected_surgery?.length
      ) {
        for (let i = 0; i < this.surg.selected_surgery.length; i++) {
          if (i <= this.surg.initial_selected_surgery.length - 1) continue;
          const orderFormatted = this.getFormattedOrders(
            [this.surg.selected_surgery[i]],
            i
          );
          const success = await this.callSurgeryOrdersAPI({
            action: "create",
            surgery_id,
            data: orderFormatted[0]
          });
          if (!success) {
            this.isLoading = false;
            return false;
          }
        }
      }

      this.setInitialSurgeryOrders(surgery_id);
      this.isLoading = false;
      return true;
    },
    async setInitialSurgeryOrders(surgery_id) {
      const resOrders = await this.$API.getSurgeryOrders(surgery_id);
      if (!resOrders || resOrders.status !== "OK" || !resOrders.data?.orders)
        return;

      let selected_surgery = [];
      const current_surgery = resOrders.data?.orders;
      current_surgery.map(s => {
        if (s.tafnit_code === "9000") return;

        const duration = s.duration
          ? this.$moment.utc(s.duration * 1000).format("HH:mm")
          : "HH:mm";
        selected_surgery.push({
          // surgery_category: s.surgery_category ?? "",
          id: s.id,
          is_primary: s.is_primary || "",
          code_name_clinical: s.icd9_procedure,
          code_name_hospital: s.type,
          duration: duration,
          default_surgery_duration: duration,
          side: s.side ?? "",
          additionalInfo: {
            status: s.status,
            surgery_fee: s.surgery_fee,
            reference_id: s.reference_id,
            name: "",
            foreign_id: s.foreign_id,
            fee: s.fee,
            expiration_date: s.expiration_date
          }
        });
      });

      this.surg.selected_surgery = selected_surgery;
      this.surg.initial_selected_surgery = JSON.parse(
        JSON.stringify(this.surg.selected_surgery)
      );
      this.surg.initial_selected_surgery = this.surg.initial_selected_surgery.map(
        (order, index) => {
          return {
            ...this.getFormattedOrders([order], index)[0],
            id: order.id,
            additionalInfo: order.additionalInfo
          };
        }
      );
    },
    async setTutorial(elType, intro) {
      await new Promise(resolve => setTimeout(resolve, 900));
      if (!elType) return;
      const isIntro = localStorage.getItem(elType);
      if (isIntro) return;

      const introJs = this.$intro();
      const element = document.querySelector("." + elType);

      if (!element) return;

      introJs.setOptions({
        exitOnOverlayClick: false,
        doneLabel: "הבנתי, סיים",
        nextLabel: "הבא",
        prevLabel: "הקודם",
        skipLabel: "דלג",
        steps: [
          {
            element,
            intro
          }
        ]
      });

      introJs.oncomplete(() => {
        localStorage.setItem(elType, true);
        if (!this.isMobile && elType === "intro-reference-document") {
          this.setTutorial(
            "intro-results",
            `בהתאם לדרישת קופת החולים ובהתאם לקוד הניתוח הנבחר, יש לצרף מסמך פענוח בדיקות הדמייה שקיבל המטופל מהרדיולוג.
החל מה-1.10.2024, לא תתאפשר הזמנת ניתוח ללא העלאת הפענוח המתאים.`
          );
        }
      });
      introJs.start();
    }
  },
  components: {
    SurgApprove,
    Cleave,
    Multiselect,
    SelectedSurgeryInfo,
    ActionsMsgRow,
    // InsuranceSurgeryInfo,
    CurrentDiagnosisInfo,
    PastDiagnosisInfo,
    MedicationSensitivityInfo,
    MaterialSensitivityInfo,
    MobileHeader,
    DesktopHeader,
    PatientDetails,
    AnalysisTools,
    Tags
  }
};
</script>

<style>
.autosuggest__results-container ul,
.autosuggest__results-container li {
  padding: 0;
  display: block;
}

.vs__actions {
  display: none !important;
}

.add_task_width {
  width: 130px;
}

.disabled {
  cursor: not-allowed;
  opacity: 0.5;
  pointer-events: none;
}

.section-disabled {
  cursor: not-allowed;
  opacity: 0.5;
  pointer-events: none;
}

.required-txt {
  padding: 0 12px 12px;
  color: #b00020;
}

.center {
  text-align: center;
}

.surg-clear-btn {
  padding: 5px;
  font-size: 0.85rem;
  position: absolute;
  top: 22px;
  left: 20px;
  z-index: 1;
  cursor: pointer;
  background-color: rgb(240 240 240);
}

.btn-mobile {
  background-color: white;
  top: 14px;
  left: 0px;
}

.surg-side-note {
  display: block;
}

@media only screen and (max-width: 800px) {
  .surg-side-note {
    width: 336px;
  }
}
@media only screen and (min-width: 1200px) {
  .file_row {
    width: 100% !important;
    margin-top: 23px;
  }
  .file_row .add_new_row_col2 {
    width: calc((100% / 3) - 20px);
  }
}
</style>
